export const LANG_IT_NAME = 'it'

export const LANG_IT_TRANS = {
  INVALID_OBJECT_ID: 'ID documento non valido',
  MISSING_OBJECT_ID: 'ID documento non presente',
  EMPTY_DOCUMENT: 'Documento vuoto',
  DOCUMENT_VALIDATION_ERROR: 'Documento non valido',
  MISSING_UNIQUE_KEY: 'Chiave univoca mancante',
  MISSING_AUTH_DATA: 'Autenticazione mancante',
  CREDENTIALS_NOT_VALID: 'Credenziali non valide',
  MISSING_MANDATORY_PRAMETER: 'Dati obbligatori mancanti',
  TOKEN_NOT_DatiVALID: 'Autenticazione non valida',
  DOCUMENT_NOT_FOUND: 'Documento non trovato',
  INCOMPATIBLE_CHANGE_STATUS: 'Azione non valida',
  DUPLICATED_DOCUMENT: 'Documento duplicato',
  REMOTE_UNREACHABLE: 'Servizio momentaneamente non disponibile',
  REMOTE_API_ERROR: 'Errore API esterna',
  GENERIC_ERROR: 'Errore generico',
  MALFORMED_BODY: 'Richiesta non valida',
  ERROR_CALLING_EXTERNAL_API: 'Errore API corriere',
  'Something went wrong. Try again later.':
    'Ops, qualcosa è andato storto. Riprova più tardi',
  'Can add orders from closed bordereau':
    'Non è possibile aggiungere ordini ad un bordereau in stato SPEDITO',
  'Can remove orders from closed bordereau':
    'non è possibile rimuovere ordini da un bordereau in stato SPEDITO',
  'Cannot ship more quantity than ordererd':
    'Non puoi spedire più quantità di quella ordinata',
  'Cant add specified product or same location is already set':
    'Impossibile aggiungere prodotto o locazione già presente',
  'Cant change status': 'Impossibile cambiare stato',
  'Cant delete closed bordereau':
    'Non è possibile eliminare bordereau in stato SPEDITO',
  'Cant find generic carrier for this warehouse ':
    'Corriere generico non settato per questo magazzino',
  'Cant find shipment for the specified order':
    'Nessuna spedizione trovata per questo ordine',
  'Cant find specifed product': 'Prodotto non trovato',
  'Cant find specified location': 'Locazione non trovata',
  'Cant find specified order': 'Ordine non trovato',
  'Cant find specified payment type':
    'Impossibile trovare il pagamento specificato',
  'Cant find specified product': 'Prodotto non trovato',
  'Cant find valid user role': 'Ruole utente non valido',
  'Cant find valid user session': 'Sessione utente non valida',
  'Document is not unique': 'Il documento non è univoco',
  'Error during token decoding': 'Errore durante la decodifica del token',
  'ID list is not an array': 'ID list non è un array',
  'Invalid attribute ID': 'ID attributo non valido',
  'Invalid ID': 'ID non valido',
  'Invalid location label': 'Etichetta locazione non valida',
  'Invalid mission ID': 'ID missione non valido',
  'Invalid mission status update': 'Aggiornato stato missione non valido',
  'Invalid options': 'Opzione non valida',
  'Invalid order ID': 'ID ordine non valido',
  'Invalid picking list ID': 'ID picking list non trovato',
  'Invalid product ID': 'ID prodotto non valido',
  'Invalid reason ID': 'ID causale non valido',
  'Invalid request body': 'Invalid request body',
  'Invalid resource ID': 'ID risorsa non valido',
  'Invalid tag ID': 'Tag ID non valido',
  'Invalid value': 'Valore non valido',
  'Invalid value entry': 'Valore non valido',
  'KITs cant have location': 'KIT non possono avere locazioni',
  'Login failed': 'Login fallito',
  'Login failed: provide a username and password':
    'Login fallito: inserire nome utente e password',
  'Malformed mission': 'Missione malformata',
  'Malformed picking list data': 'Dati picking list malformati',
  'Malformed picking list orders data': 'Dati ordini picking list malformati',
  'Missing auth token': 'Token di autorizzazione mancante',
  'Missing brands id': 'ID brand non trovato',
  'Missing categories id': 'ID categoria mancante',
  'Missing mandatory param': 'Parametro obblgiatorio mancante',
  'Missing mandatory parameters': 'Manca un parametro obbligatorio',
  'Missing manufacturers id': 'Manca ID produttore',
  'Missing product ID': 'Manca ID del prodotto',
  'Missing query parameters': 'Parametro query mancante',
  'Missing tote code': 'Manca codice UDC',
  'Missing user': 'Utente mancante',
  'Missing value': 'Valore mancante',
  'Missing value label': 'Manca valore etichetta',
  'Mission product not found': 'Prodotto non trovato per la missione',
  'More than one product found': 'Prodotti multipli trovati',
  'Movements must be under transaction':
    'I movimenti devono essere contenuti in una transaction',
  'No active session found': 'Nessuna sessione attiva',
  'No available actions': 'Non ci sono azioni disponibili.',
  'No product found': 'Prodotto non trovato',
  'Order is not confirmed': "L'ordine non è in stato CONFERMATO",
  'Order not found': 'Ordine non trovato',
  'Packing list is not in processing status':
    'La packing list non è IN LAVORAZIONE',
  'Picking list not in processing status':
    'La picking list non è IN LAVORAZIONE',
  'Pickinglist orders property must be an array':
    'La proprietà orders nelle pickinglist deve essere un array',
  'Product not found': 'Prodotto non trovato',
  'Product added': 'Prodotto aggiunto',
  'Product to move does not exists': 'Prodotto da trasferire non esistente',
  'Provide +|- to use with $inc operator':
    "Utilizza +|-|= per usare l'operatore  $inc",
  'Provide +|-|= to use with $inc operator':
    "Utilizza +|-|= per usare l'operatore  $inc",
  'Provide a valid username': 'Inserisci un nome utente valido',
  'Qty to move is negative': 'Quantità da trasferire negativa',
  'Qty to move is not an integer':
    'La quantità da trasferiere non è un intero positivo',
  'Quantity must be a positive integer':
    'La quantità deve essere un numero intero positivo',
  'Quantity must me an integer':
    'Quantità deve essere un numero intero positivo',
  'Quantity must me positive': 'Quantità deve essere un numero positivo',
  'Quantity parameter is mandatory': 'La quantità è obbligatoria',
  'Reason not compatible with movement':
    'Causale non compatibile con il movimento',
  'Reason not found': 'Causale di movimentazione non trovata',
  'Select options not an array': '',
  'Some nodes are not reachable from the starting point':
    'Alcuni nodi non sono raggiungibili dal punto di partenza',
  'Source and target location are the same':
    'Stessa locazione di partenza e destinazione',
  'Source location does not exists': 'La locazione di partenza non esiste',
  'Source location not found': 'Locazione di partenza non trovata',
  'Starting location is mandatory for building pickpath ':
    'Locazione di partenza obbligatoria per generare il percorso di picking',
  'StartVertex is missing from graph': 'StartVertex mancante',
  'Target attribute not found': '',
  'Target location does not exists': 'La locazione di destinazione non esiste',
  'Target location not found': 'Locazione di destinazione non trovata',
  'Target order not found': '',
  'Target packing list not found': '',
  'Picking list not found': 'Picking list non trovata',
  'Target product location has not picked items': '',
  'Target product not found': '',
  'Target tag not found': '',
  'Target warehouse not found': 'Magazzino di destinazione non trovato',
  'The attribute value is an empty string': 'Inserire un valore valido',
  'The attribute value is not a boolean': 'Il valore non è un booleano',
  'The attribute value is not a number':
    'Il valore inserito deve essere un numero',
  'The attribute value is not a string': 'Il valore non è una stringa',
  'The attribute value is not an integer':
    'Il valore inserito deve essere un intero',
  'The attribute value is too long': 'Valore attributo troppo lungo',
  'The attribute value is too short': 'Valore attributo troppo corto',
  'The attribute value must be a finite number':
    'Il valore deve essere un numero',
  'The old password provided is wrong':
    'La vecchia password inserita non è valida',
  'The parent location must be root':
    'La locazione padre deve essere la radice',
  'The picked qty must be an integer':
    'La quantità deve essere un  numero intero',
  'The picked qty must be positive or zero':
    'La quantità deve essere un numero intero positivo',
  'The picking list is not in PENDING status':
    'La picking list non è in stato DA PRELEVARE',
  'The source location does not contains this product':
    'Prodotto non presente nella locazione di partenza',
  'The source location does not have enough qty to move':
    'Quantità da trasferire maggiore della giacenza',
  'The source location is reserved':
    'Sono presenti prodotti riservati ad una picking list',
  'The value have to be an object': 'Il valore deve essere un oggetto',
  'There are attribute values': 'Sono presenti dei valori per questo attributo',
  'There are inventory items that are assigned to this warehouse':
    'Sono presenti prodotti assegnati a questo magazzino',
  'There are locations with connected products':
    'Il prodotto è presente in alcuni locazioni',
  'There are missing picking locations Check warehouse structure':
    'Locazioni picking mancanti. Controllare struttura magazzino',
  'There are orders that contains this product':
    'Il prodotto è presente in alcuni ordini',
  'There are orders with this payment type':
    'Sono presenti ordini con il metodo di pagamento specificato',
  'There are prodcuts that uses this brand':
    'Prodotti collegati a questo brand',
  'There are prodcuts that uses this manufacturer':
    'Prodotti collegati a questo produttore',
  'There are users items that are assigned to this warehouse':
    'Sono presenti utenti assegnati a questo magazzino',
  'There is already a brand with that name': 'Brand già presente',
  'There is already a manufacturer with that name': 'Produttore già presente',
  'There is already an active session': 'Sessione utente già attiva',
  'There is already an attribute with that code':
    'È già presente un attributo con questo codice',
  'There is more than one shipment for this order':
    'È presente più di una spedizione per questo ordine',
  'There is no sufficient stock left': "Non c'è sufficiente giacenza",
  'There is not a currently active packing list':
    'Non ci sono packing list attive',
  'This action is not available': 'Azione non disponibile',
  'This order is inside a picking list':
    "L'ordine è inserito in una packing list",
  'This packing list already exists': 'Packing list già esistente',
  'This tenant doesnt have any ftp set':
    'Questo tenant non ha profili FTP associati',
  'This tenant hasnt any carriers':
    'Il tenant non ha nessun corriere impostato',
  'This tote is used by another picking list':
    "UDC utilizzata per un'altra picking list",
  'This value is already assigned': 'Valore già assegnato',
  'Token not valid.': 'Token non valido',
  'Too much qty packed': 'Quantità imballata maggiore della richiesta',
  'Tote used by another order': 'UDC utilizzata per un altro ordine',
  'Unable to a valid action': '',
  'Unable to delete this category': 'Impossibile eliminare categoria',
  'Unable to delete this tag': 'Non è possibile cancellare il tag',
  'Unable to fetch product data': 'Impossibile reperire informazioni prodotto',
  'Unable to fetch product info':
    'Impossibile ottenere informazioni del prodotto',
  'Unable to find a valid mission for the current order':
    "Impossibile trovare missioni valide per l'ordine corrente",
  'Unable to find a valid picking list':
    'Impossibile trovare una picking list valida',
  'Unable to find a valid picking list to update':
    'Impossibile trovare una picking list da aggiornare',
  'Unable to find Amazon and eBay channels for the current tenant':
    'Impossibile trovare canale Amazon e eBay per questo tenant',
  'Unable to find the current mission': 'Impossibil trovare missione corrente',
  'Unable to find the current order': 'Impossibile trovare ordine corrente',
  'Unable to find the Ecommerce channel for the current tenant':
    'Impossibile trovare canale Ecommerce per questo tenant',
  'Unable to find the packed order': "Impossibile trovare l'ordine imballato",
  'Unable to find the packing list to update':
    'Impossibile trovare packing list da aggiornare',
  'Unable to find the picking list': 'Picking list non trovata',
  'Unable to find the product': 'Prodotto non trovato',
  'Unable to find the target tote': 'Impossibile trovare UDC di destinazione',
  'Unable to find the tote inside product locations':
    'UDC non trovata nelle locazioni prodotto',
  'Unable to load tote information': 'Impossibile reperire informazioni UDC',
  'Unexpected quantity to pack': 'Quantità da imballare sbagliata',
  'Unexpected tenant': 'Unexpected tenant',
  'Unknown action': 'Azione sconosciuta',
  'User not found': 'Utente non trovato',
  'User permissions are too low to access this resource':
    'Permessi utenti insufficienti per accedere a questa risorsa',
  'Wrong password provided': 'Password errata',
  'Wrong product': 'Prodotto errato',
  'Wrong tote': 'UDC errata',
  'Xlsx file header doesnt match the template file':
    'Il file non corrisponde con il template di importazione',
  'You are not authorized to access this resource':
    'Accesso alla risorsa non autorizzato',
  'You can only test when the picking list is in PENDING status':
    'La simulazione evasione è attiva solo in stato DA PRELEVARE',
  'You cannot change the attribute code':
    'Non è possibile cambiare il codice attributo',
  'You cannot change the attribute kind':
    'Non è possibile cambiare il tipo di attributo',
  'You cannot make an existing attribute unique':
    'Non è possibile settare un attributo esistente come univoco',
  'You cannot skip the last mission': "Non puoi saltare l'ultima missione",
  'You cannot skip the last order': "Non puoi saltare l'ultimo ordine",
  'You have to close the current packing list':
    "Devi concludere l'imballaggio della packinglist corrente prima di iniziare con un'altra",
  'You have to specify a custom reason':
    'Specificare causale di movimentazione',
  'Not Found': 'Elemento non trovato',
  'There are orders that contains this product.':
    'Ci sono ordini che contengono questo prodotto',
  'Missing pickinglocation from the warehouse.':
    'Ubicazioni di prelievo mancanti per questo magazzino',
  'Missing required attribute': 'Configurazioni obbligatorie mancanti',
  'rcpt_prov: deve essere lungo al massimo 2 caratteri':
    'Provincia indirizzo di spedizione non valido',
  'dmo-availability': 'DMO export DISPONIBILITA',
  'dmo-bolced': 'DMO import BOLCED',
  'dmo-carced': 'DMO export CARCED',
  'dmo-invced': 'DMO export INVCED',
  'dmo-magart': 'DMO import MAGART',
  'dmo-mapping': 'DMO import MAPPINGSKU-CART',
  'dmo-ordcli': 'DMO Export ORDCLI',
  'dmo-orders': 'DMO import ORDINI Ecommerce',
  'dmo-tracking': 'DMO export TRACKING',
  'dmo-status': 'DMO export STATUS ordini',
  'trilab-dropship': 'Ordini Droshipping',
  'trilab-magento-shipments': 'Magento shipments',
  'trilab-store360-orders': 'Ordini Store360',
  'trilab-magento-orders': 'Ordini Magento',
  'trilab-store360-shipments': 'Store360 shipments',
  'trilab-magento-availability': 'Disponibilità ecommerce',
  'trilab-excel-availability': 'Catalogo Excel',
  'amica-category': 'Export CATEGORY',
  'amica-eavs': 'Export EAVS',
  'amica-ite': 'Export ITE',
  'amica-prices': 'Export PRICES',
  'amica-stock': 'Export STOCK',
  'bene-exp-legacy': 'Export prodotti',
  'bene-imp-legacy': 'Import ordini',
  'Unable to pack this product': 'Non è possibile imballare questo prodotto',
  ORDERS_FILE: 'File ordini',
  ROWS_FILE: 'File righe',
  FTP_HOST: 'Host',
  FTP_PORT: 'Porta',
  FTP_USERNAME: 'Username',
  FTP_PASSWORD: 'Password',
  FTP_ACTION: 'Azione FTP',
  SOURCE_FILE: 'Nome file:',
  SOURCE_DIRECTORY: 'Cartella sorgente',
  SOURCE_PATTERN: 'Pattern sorgente',
  TARGET_FILE: 'Nome file destinazione',
  TARGET_DIRECTORY: 'Cartella destinazione',
  TARGET_PATTERN: 'Pattern destinazione',
  RECEIVER_MAIL: 'Email',
  'Unable to close the order if there is at least one unopened goods arrival':
    "Non è possibile chiudere l'ordine a fornitore se sono presenti degli arrivi merce ancora in lavorazione",
  'Found a product location not castable':
    'Prodotto impegnato in pickinglist o in attesa di imballaggio',
  "Can't find location on the product.":
    'Ubicazione non trovata per questo prodotto',
  'Product is not managed by batches.': 'Il prodotto non è gestito a lotti',
  'This location has reservedQty > 0.':
    'Ubicazione con quantità riservate a picking list',
  'New signature is already present in the batches.':
    "Lotto già presente nell'ubicazione selezionata",
  'Invalid newQty: must be minor than old batch onHandQty.':
    "Quantità non valida: dev'essere minore alla giacenza",
  'Invalid newQty: must be > 0.':
    "Quantità non valida: dev'essere maggiore di 0",
  'Provide two different batches.':
    'É necessario indicare un lotto diverso da quello già presente',
  'Unable to reserve this batch':
    'Non è stato possibile riservare la quantità richiesta',
  'Tote already used by another picking list':
    "UDC già utilizzata da un'altra picking list",
  'Unable to retrieve the required entity': 'Elemento non trovato',
  'ERRORE CORRIERE PRODUZIONE ETICHETTA':
    'Controllare indirizzo spedizione ordine (lunghezza max 35 caratteri, indirizzo/provincia non valida, caratteri speciali, etc.)',
  WAREHOUSE_ID: 'Magazzino',
  FULL_CATALOG: 'Intero catalogo',
  Warehouse: 'Magazzino',
  EMUT_INVALID_WRITE: 'Documento non valido',
  'Cannot update an entity with an invalid value':
    'Controllare che tutti i valori del documento siano validi',
  EMUT_INVALID_READ: 'Documento non valido',
  'Cannot read an entity with an invalid value':
    'Il documento che si sta cercando di leggere non è valido',
  INVALID_CREDENTIALS: 'Credenziali non valide',
  'Invalid credentials': 'Username e/o password errati',
  NOT_AUTHORIZED: 'Non autorizzato',
  "You haven't the authorization to perform this action":
    'Non sei autorizzato ad effettuare questa azione',
  EMUT_INVALID_DATA: 'Documento non valido',
  'Unusable data found': 'Struttura documento non valida',
  EMUT_INVALID_ENTITY: 'Documento non valido',
  'Current entity does not match the configured schema':
    'Struttura documento non valida',
  NOT_AUTHENTICATED: 'Non autenticato',
  'Session was invalidated': 'Sessione scaduta',
  INTERNAL_ERROR: 'Richiesta non eseguita',
  'An error occurred':
    "Qualcosa è andato storto durante l'esecuzione della richiesta",
  PASSWORD_RESET_REQUIRES_EMAIL: 'Utente senza email associata',
  'This account does not have an email configured':
    'Per poter resettare la password è necessaria una email associata al proprio profilo.',
  CHANGE_PASSWORD_REQUIRED: 'Aggiornamento password richiesto',
  'The current password must be changed':
    "E' necessario aggiornare la password corrente",
  USER_WRONG_PASSWORD: 'Password corrente errata',
  'The provided password is wrong': 'La password indicata è errata',
  'Current access token was invalidated':
    'La sessione corrente non è più valida',
  ROLE_USED: 'Ruolo assegnato',
  'This role is currently used by some users.':
    'Questo ruolo è attualmente assegnato ad utenti',
  'There are child products linked to this product':
    'Ci sono delle varianti collegate a questo prodotto',
  'Product linked to a parent product':
    'Prodotto collegato ad un prodotto padre',
  'You need to end the packing list to do so.':
    "E' necessario terminare la packing list per poter annullare l'ordine.",
  OP_ATTRIBUTE_IS_USED: 'Attributo utilizzato',
  'This attribute is currently used by some products':
    'Questo attributo è attualmente utilizzato in alcuni prodotti.',
  DISABLED_USER: 'Accesso non consentito',
  'User disabled': 'Utente disabilitato',
  'Wrong entity status': "Stato documento non valido per l'azione richiesta",
  'User was disabled': 'Utente disabilitato',
  'This feature is not available with legacy authentication':
    'Funzionalità non disponibile',
  'Access token not provided': 'Sessione scaduta',
  'This token is not usable for this URL':
    'Token non utilizzabile per questa richiesta',
  'You do not posses the required permissions to perform this action.':
    "Non possiedi i permessi necessari per eseguire l'azione",
  'Unable to delete this category, there are child categories':
    'Categoria padre di altre categorie.',
  'Unable to delete this category, there are connected products':
    'Categoria assegnata a prodotti.',
  "Can't find shipment for the specified order.":
    "Nessuna etichetta trovata per quest'ordine",
  VALIDATION_ERROR: 'Documento non valido',
  'Unable to delete this family, there are products using it.':
    'Famiglia assegnata a prodotti.',
  OP_PACKING_PARTIAL: 'Imballo parziale',
  'This order is not fully packed': 'Ordine non completamente imballato.',
  'body.file.mimetype should be equal to constant':
    'Estensione file non accettata.',
  'The server refuse to process the request':
    "Non è stato possibile effettuare l'operazione.",
  'Recipient emails': 'Email destinatari',
  'You cannot remove all orders from this bordereau':
    'Non è possibile rimuovere tutti gli ordini da una distinta.',
  'Unable to delete this group, there are connected attributes':
    'Non è possibile eliminare questo gruppo, sono presenti degli attributi collegati.',
  Italian: 'Italiano',
  'Postal code is required for GLS shipments.':
    'CAP obbligatorio per spedizioni GLS.',
  'Province is required for GLS shipments.':
    'Provincia obbligatoria per spedizioni GLS.',
  'Missing carrier service.': 'Servizio corriere richiesto.',
  'Shipping address must have a postal code.':
    'CAP indirizzo di spedizione richiesto.',
  'Shipping address must have a phone number.':
    'Numero di telefono indirizzo di spedizione richiesto.',
  'Shipping address must have an email address.':
    'Email indirizzo di spedizione richiesto.',
  'Current warehouse must have a name.':
    'Indirizzo di partenza senza un valido nome (magazzino di gestione).',
  'Current warehouse must have a phone number.':
    'Indirizzo di partenza senza un valido numero di telefono (magazzino di gestione).',
  'Current warehouse must have an email.':
    'Indirizzo di partenza senza una valida email (magazzino di gestione).',
  'Cannot cancel this shipment.':
    'Non è possibile annullare questa spedizione.',
  'Shipment canceling is not supported for this carrier.':
    'Non è possibile annullare questa spedizione per questo corriere.',
  'The currenct shipment does not match with carrier definition.':
    "La spedizione corrente non appartiene all'attuale corriere associato.",
  'Unexpected carrier.': 'Corriere non previsto.',
  'This order does not contain any package.':
    "Non ci sono colli assegnati a quest'ordine.",
  'Billind address required.': 'Indirizzo di fatturazione richiesto.',
  'Shipping address required.': 'Indirizzo di spedizione richiesto.',
  'Recipient name required.': 'Nome destinatario richiesto.',
  'Recipient address required.': 'Indirizzo destinatario richiesto.',
  'Recipient city required.': 'Città destinatario richiesto.',
  'Recipient country code required.': 'Stato destinatario richiesto.',
  'FedEx needs a service.': 'Servizio FedEx richiesto.',
  'FedEx service not found inside the carrier data.':
    'Servizio FedEx non presente tra quelli disponibili.',
  'This label is not contained inside this shipment.':
    'Etichetta non presente nella spedizione generata dal corriere.',
  'Shipment label file not found. This could be normal for old labels.':
    'Etichetta non presente nella spedizione generata dal corriere.',
  GOODS_RECEIVE_LINKED: 'Arrivo merce collegato',
  'Cannot remove a linked row':
    'Non è possibile rimuovere una riga collegata ad un arrivo merce',
  OP_PRODUCT_NOT_FOUND: 'Prodotto non trovato',
  'No products found with this code.':
    'Nessun prodotto trovato con questo codice',
  'An error has occurred.':
    "Si è verificato un errore durante l'elaborazione della richiesta",
  Save: 'Salva',
  'Save and close': 'Salva e chiudi',
  'Active filters': 'Filtri attivi',
  Reload: 'Ricarica',
  'Reset selection': 'Resetta selezione',
  'Download excel file': 'Scarica file excel',
  'Download an excel file of the filtered items':
    'Scarica un file excel degli elementi filtrati',
  'Download an excel file of the selected items':
    'Scarica un file excel degli elementi selezionati',
  'New webhook': 'Nuovo webhook',
  'Create a new webhook': 'Crea un nuovo webhook',
  'selected webhooks': 'webhook selezionati',
  Settings: 'Impostazioni',
  'Mandatory fields': 'Campi obbligatori',
  Event: 'Evento',
  'Webhook status': 'Stato webhook',
  'Select the emission status of the webhook':
    'Seleziona lo stato di emissione del webhook',
  Url: 'Url',
  'Enter an url': 'Inserisci un url',
  'Minimum 16 characters required': 'Minimo 16 caratteri richiesti',
  'Invalid url or with insecure protocol (requires https)':
    'Url non valido o con protocollo non sicuro (richiede https)',
  'View webhook': 'Visualizza webhook',
  'Modify webhook': 'Modifica webhook',
  'Delete webhook': 'Elimina webhook',
  'There are no webhooks': 'Non ci sono webhook',
  'Add webhooks to be able to perform operations':
    'Aggiungi dei webhook per poter effettuare delle operazioni',
  'There are no elements that match your search':
    'Non ci sono elementi che soddisfano la tua ricerca',
  'Please try again by resetting or modifying your search':
    'Riprova resettando o modificando la ricerca',
  'Oops, it seems there was an error loading the elements':
    'Ops, sembra ci sia stato un errore nel caricamento degli elementi',
  'Check that your internet connection is working and try reloading the page':
    'Controlla che il tuo collegamento ad internet funzioni e prova a ricaricare la pagina',
  'Webhook configuration': 'Configurazione webhook',
  Typology: 'Tipologia',
  Cancel: 'Annulla',
  Continue: 'Continua',
  Back: 'Indietro',
  'There is already a brand with that name.':
    'Esiste già un brand con il nome indicato',
  GSPED_ERROR: 'Errore stampa etichetta',
  UNKNOWN_ERROR: 'Errore sconosciuto',
  'Unknown Error': "Non è stato possibile eseguire l'operazione richiesta",
  SUCCESS: 'Successo',
  FAILED: 'Fallito',
  CARRIER_LOCKED: 'Corriere non modificabile',
  "Cannot change this order's carrier during this status.":
    "Non è possibile modificare il corriere a causa dello stato dell'ordine",
  EXPECTED_TOTE_LOCATION: 'Ubicazione errata',
  'You can pick only with tote locations.':
    'È possibile prelevare sono con UDC',
  TOTE_ALREADY_USED: 'UDC già utilizzata',
  'This tote was already used by another order.':
    'Questa UDC è già stata utilizzata per un altro ordine.',
  'The requested resource does not exist.': 'La rotta richiesta non esiste.',
  USER_SAME_PASSWORD: 'Password combaciano',
  'The new password must be different from the old one.':
    "La nuova password dev'essere diversa dalla password attuale",
  "You haven't the authorization to perform this action.":
    'Non hai i permessi necessari per effettuare questa richiesta.',
  'querystring/q must NOT have fewer than 3 characters':
    'Inserire almeno 3 caratteri',
  CONFIRMED: 'Confermato',
  Confirmed: 'Confermato',
  'Order ready to be processed for shipping. If changes are needed, it must be put back to PENDING first':
    'Ordine pronto per essere gestito per la spedizione. In caso di modifiche va rimesso IN ATTESA',
  PROCESSING: 'In lavorazione',
  Processing: 'In lavorazione',
  'Order accepted by the warehouse. Cannot be modified':
    'Ordine preso in carico da parte del magazzino. Non può essere modificato',
  PACKED: 'Imballata',
  PARKED: 'Ricevuto',
  PRINTED: 'Chiusa',
  PROCESSED: 'Processato',
  Processed: 'Processato',
  'Order already picked and awaiting packaging with carrier label printing. Quantities already unloaded from the warehouse':
    'Ordine già prelevato in attesa di essere imballato con stampa etichetta vettore. Quantità già scaricate dal magazzino',
  ASSIGNED: 'Assegnato',
  'Assigned m': 'Assegnato',
  RECEIVED: 'Ricevuto',
  Received: 'Ricevuto',
  'Order parked at a pickup point waiting for the customer':
    'Ordine parcheggiato in un pickup point in attesa del cliente',
  RETURNING: 'In attesa',
  Pending: 'In attesa',
  'It commits the quantities in stock but still awaiting CONFIRMATION in order to be managed':
    'Impegna le quantità a magazzino ma rimane in attesa di CONFERMA per poter essere gestito',
  CLOSED: 'Chiuso',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel',
  "body/printers must have required property 'labels'":
    'Seleziona una stampante per le etichette.',
  "body/printers must have required property 'a4'":
    'Seleziona una stampante A4',
  Views: 'Viste',
  'Download views filtered file': 'Scarica un file excel delle viste filtrate',
  'New view': 'Nuova vista',
  'Create a new view': 'Crea una nuova vista',
  'selected views': 'viste selezionate',
  'Reload page': 'Ricarica pagina',
  'View configuration': 'Configurazione vista',
  Products: 'Prodotti',
  Fields: 'Campi',
  Field: 'Campo',
  'Customer orders': 'Ordini clienti',
  'Supplier orders': 'Ordini fornitore',
  'Goods receives': 'Arrivi merce',
  Sales: 'Vendite',
  'Picking lists': 'Picking list',
  'Picking list': 'Picking list',
  'New custom view': 'Nuova vista personalizzata',
  'Main data': 'Dati principali',
  Name: 'Nome',
  'Name of the view': 'Nome della vista',
  'Shared with other users': 'Condivisa con altri utenti',
  'Table columns': 'Colonne della tabella',
  Filters: 'Filtri',
  Parameters: 'Parametri',
  'Custom view': 'Vista personalizzata',
  'Add field': 'Aggiungi campo',
  'Add attribute': 'Aggiungi attributo',
  Columns: 'Colonne',
  'New field': 'Nuovo campo',
  'New attribute': 'Nuovo attributo',
  'No fields configured': 'Non ci sono campi configurati',
  'Add filter': 'Aggiungi filtro',
  'New filter': 'Nuovo filtro',
  'No filters configured': 'Non ci sono filtri configurati',
  Operator: 'Operatore',
  Currency: 'Valuta',
  Value: 'Valore',
  'No params configured': 'Non ci sono parametri configurati',
  'Add param': 'Aggiungi parametro',
  'New param': 'Nuovo parametro',
  Catalog: 'Catalogo',
  Supplier: 'Fornitore',
  'Invalid invoiced quantity': 'Quantità fatturata non valida',
  CONFLICTING_STATUS_CHANGE: 'Richiesta non completata',
  Param: 'Parametro',
  UNAUTHORIZED: 'Non autorizzato',
  'Views management': 'Gestione viste',
  'Views available': 'Viste disponibili',
  'All groups': 'Tutti i gruppi',
  All: 'Tutto',
  ALL: 'Tutto',
  Attribute: 'Attributo',
  'Related products': 'Prodotti associati',
  Attention: 'Attenzione',
  'Brand saved successfully': 'Brand salvato con successo',
  'Fill out the form with all the necessary data':
    'Compilare il form con tutti i dati necessari',
  'View name': 'Nome vista',
  'Field required': 'Campo richiesto',
  'Set default fields': 'Imposta campi di default',
  'Set default': 'Imposta default',
  "body must have required property 'name'": 'Campo "nome" richiesto',
  true: 'Vero',
  false: 'Falso',
  Navigation: 'Navigazione',
  General: 'Generale',
  Areas: 'Aree',
  Locations: 'Ubicazioni',
  Totes: 'Unità di carico',
  Carriers: 'Corrieri',
  'New warehouse': 'Nuovo magazzino',
  'Clear selection': 'Annulla selezione',
  'warehouses selected': 'magazzini selezionati',
  'Download file': 'Scarica file',
  'Download XLS file': 'Scarica file XLS',
  'Upload XLS file': 'Carica file XLS',
  'Create a new warehouse': 'Crea un nuovo magazzino',
  'Actions available': 'Azioni disponibili',
  'Print labels': 'Stampa etichette',
  'Back to the list': 'Torna alla lista',
  'Save warehouse': 'Salva il magazzino',
  'Save warehouse %s': 'Salva il magazzino %s',
  'Save the warehouse %s and go back':
    'Salva il magazzino %s e torna alla lista',
  Structure: 'Struttura',
  Logistic: 'Logistica',
  'Add carrier': 'Aggiungi corriere',
  'No carriers linked': 'Nessun corriere collegato',
  Carrier: 'Corriere',
  'Link carrier': 'Collega corriere',
  'Set carrier %s as default': 'Imposta %s come corriere di default',
  'Unlink carrier %s from warehouse': 'Rimuovi %s come corriere del magazzino',
  'Link a carrier to the warehouse': 'Collega un corriere al magazzino',
  'Warehouse saved successfully': 'Magazzino salvato con successo',
  'No areas configured': 'Nessuna area configurata',
  'Add area': 'Aggiungi area',
  'Totes amount': 'Quantità UDC',
  'Add totes': 'Aggiungi UDC',
  Warehouses: 'Magazzini',
  warehouses: 'magazzini',
  'Own warehouse': 'Magazzino proprio',
  'Shared warehouse': 'Magazzino condiviso',
  'External ref.': 'Rif. esterno',
  'External reference': 'Riferimento esterno',
  MODIFIED: 'MODIFICATO',
  Type: 'Tipologia',
  'Label length': 'Lung. codice',
  NUMBERS: 'NUMERI',
  LETTERS: 'LETTERE',
  'New area': 'Nuova area',
  Aisle: 'Corsia',
  Aisles: 'Corsie',
  Rack: 'Scaffale',
  Racks: 'Scaffali',
  Shelf: 'Livello',
  Shelves: 'Livelli',
  Positions: 'Posizioni',
  Position: 'Posizione',
  Compartments: 'Scomparti',
  Compartment: 'Scomparto',
  'Add %s': 'Aggiungi %s',
  'Amount of %s': 'Quantità di %s',
  'Configure %s': 'Configura %s',
  'Picking method': 'Modalità di prelievo',
  Disposition: 'Disposizione',
  'Area saved successfully': 'Area salvata con successo',
  'Area deleted successfully': 'Area eliminata con successo',
  'Totes saved successfully': 'Unità di carico salvate con successo',
  'locations selected': 'ubicazioni selezionate',
  'Print the labels of the selected locations':
    'Stampa le etichette delle ubicazioni selezionate',
  'Locations printed successfully': 'Ubicazioni stampate con successo',
  'Ticket pallet printed successfully': 'Ticket pallet stampati con successo',
  'Tenants invited': 'Tenant invitati',
  'No tenants invited': 'Nessun tenant invitato',
  'Invite tenant': 'Invita tenant',
  'Invite a tenant to the warehouse':
    'Invita un tenant ad accedere al magazzino',
  Prefix: 'Prefisso',
  Invite: 'Invita',
  'Tenant invited successfully': 'Tenant invitato con successo',
  'Tenant rejected successfully': 'Tenant espulso con successo',
  'Invited at %s': 'Invitato in data %s',
  'Delete area %s': "Elimina l'area %s",
  'Edit area': 'Modifica area',
  'Edit area %s': "Modifica l'area",
  'Warehouse deleted successfully': 'Magazzino eliminato con successo',
  'Personal view': 'Vista personale',
  'Shared view': 'Vista condivisa',
  'Default view': 'Vista predefinita',
  'New channel': 'Nuovo canale',
  'Locations update started': 'Aggiornamento ubicazioni iniziato',
  'Changes will be available soon': 'Le modifiche saranno presto disponibili',
  'Reload locations': 'Ricarica ubicazioni',
  'Print ticket pallet': 'Stampa ticket pallet',
  'Create carrier pallet': 'Crea pallet corriere',
  'Delete pallet': 'Elimina pallet',
  'You are about to delete this pallet. Proceed with deletion?':
    "Stai per eliminare questo pallet. Procedere all'eliminazione?",
  'Pallete deleted successfully': 'Pallet eliminato con successo',
  'Location models': 'Modelli di ubicazione',
  'No models available': 'Nessun modello disponibile',
  'Create a new location model': 'Crea un nuovo modello',
  'Add model': 'Aggiungi modello',
  'Create model': 'Crea modello',
  'Edit model': 'Modifica modello',
  'Model saved successfully': 'Modello salvato con successo',
  'Model deleted successfully': 'Modello eliminato con successo',
  'Create a new area': 'Crea una nuova area',
  'Create new totes': 'Crea nuove unità di carico',
  'Select carrier': 'Seleziona corriere',
  'Modify locations': 'Modifica ubicazioni',
  'Modify filtered locations': 'Modifica ubicazioni filtrate',
  'Modify locations status': 'Modifica stato ubicazioni',
  'Modify filtered locations status':
    'Modifica lo stato delle ubicazioni filtrate',
  'Modify selected locations status':
    'Modifica la stato delle ubicazioni selezionate',
  Visibility: 'Visibilità',
  'Locations visibility': 'Visibilità ubicazioni',
  'Modify %s locations': 'Modifica %s ubicazioni',
  Enabled: 'Abilitato',
  Disabled: 'Disabilitato',
  True: 'Vero',
  False: 'Falso',
  'Modify locations model': 'Modifica modello ubicazioni',
  'Modify filtered locations model':
    'Modifica il modello delle ubicazioni filtrate',
  'Modify selected locations model':
    'Modifica il modello delle ubicazioni selezionate',
  Model: 'Modello',
  'Locations model': 'Modello ubicazioni',
  Apply: 'Applica',
  Uncategorized: 'Non categorizzati',
  'All products': 'Tutti i prodotti',
  Task: 'Attività',
  Tasks: 'Attività',
  'No tasks available': 'Nessuna attività disponibile',
  'Activity execution': 'Esecuzione attività',
  'Orders update': 'Aggiornamento ordini',
  'Products update': 'Aggiornamento prodotti',
  'Warehouse update': 'Aggiornamento magazzino',
  'Replenishments update': 'Aggiornamento missioni di trasferimento',
  Completed: 'Completato',
  Failed: 'Fallito',
  Running: 'In lavorazione',
  'Load more': 'Carica ancora',
  'Total tasks': 'Attività totali',
  'Last tasks': 'Ultime attività',
  'Authorization info are not provided.':
    'Login effettuato su un altro dispositivo.',
  WRITE_CONFLICT: 'Conflitto di aggiornamento',
  'This Product was updated by another User.':
    'Questo prodotto è stato aggiornato da un altro uDisabilitatente. Ricaricalo per poterlo modificare.',
  Delete: 'Elimina',
  'Brand deleted successfully': 'Brand eliminato con successo',
  'Customer deleted successfully': 'Cliente eliminato con successo',
  'Some fields are not filled in correctly':
    'Alcuni campi non sono compilati correttamente',
  'Created at': 'Creato il',
  'Created by': 'Creato da',
  'Updated at': 'Modificato il',
  'Updated by': 'Modificato da',
  'Catalog saved successfully': 'Catalogo salvato con successo',
  'Catalog deleted successfully': 'Catalogo eliminato con successo',
  'The default catalog shoud have the default language':
    'Il catalogo di default dovrebbe avere la lingua di default',
  Warning: 'Attenzione',
  'Storeden missing fields':
    'É necessario mappare tutti i campi obbligatori per configurare correttamente Storeden',
  'Channel saved successfully': 'Canale di vendita creato con successo',
  'Channel deleted successfully': 'Canale di vendita eliminato con successo',
  'Channel sync started': 'Sincronizzazione canale esterno iniziata',
  'Channel integration created successfully':
    'Collegamento canale esterno creato con successo',
  'Channel connected to external channel':
    'Canale di vendita collegato al canale di vendita esterno',
  'Channel disconnected from external channel':
    'Canale di vendita scollegato dal canale di vendita esterno',
  'An unknown error has prevented the connection. Please contact the support.':
    'Errore imprevisto durante il collegamento del canale, contattare il supporto clienti.',
  'Integrated Channels must be disconnected before deletion.':
    "È necessario disconnettere il canale prima dell'eliminazione",
  'Tote without picking-lists': 'Nessuna picking list associata a questa UDC',
  'Picking orders not packable':
    'Nessun ordine da imballare nella picking list',
  'Tote not found': 'UDC non trovata',
  Confirm: 'Conferma',
  Success: 'Successo',
  'Order successfully updated': 'Ordine aggiornato con successo',
  'Order label printed': 'Etichetta ordine stampata',
  'Order not selected': 'Ordine non selezionato',
  'Order successfully packed': 'Ordine imballato con successo',
  'Packing-list started by another user':
    'Packing-list iniziata da un altro utente',
  'Please contact the office': "Contattare l'ufficio",
  'Picking without totes': 'Picking-list senza UDC',
  'Printers not selected': 'Stampanti non selezionate',
  'Product not contained in the current order':
    "Prodotto non contenuto nell'ordine corrente",
  'Product not contained in the current packing-list':
    'Prodotto non contenuto nella picking-list corrente',
  'Unable to pack this location': "Non è possibile imballare l'UDC corrente",
  SHIPMENT_LABEL_NOT_FOUND: 'Etichetta corriere non trovata',
  'Product already packed': 'Prodotto già imballato',
  'Station not selected': 'Dati postazione non selezionati',
  'Tote Location not found.': 'UDC non trovata',
  'body/email must match format "email"': 'Email non valida',
  'Eject tenant %s from warehouse': 'Rimuovi il tenant %s dal magazzino',
  'Modify model %s': 'Modifica modello %s',
  'Delete model %s': 'Elimina modello %s',
  "Wrapper child's barcode is missing.": 'Barcode imballo mancante.',
  "Wrapper's child is missing.": 'Imballo figlio mancante',
  "Wrapper barcode's quantity mismatch.":
    'Quantità imballi non combaciano con quantità barcode',
  'Quantified barcodes need a wrapper.':
    'Barcode con quantità richiedono un imballo',
  'Packing quantity overflow.': 'Quantità pezzi imballo in eccesso',
  CANCELED: 'Annullato',
  Canceled: 'Annullato',
  'This does NOT commit the quantities in stock. The order is permanently cancelled and no further transactions can be made on it':
    "NON impegna le quantità a magazzino. L'ordine è definitivamente annullato e non è possibile effettuare ulteriori operazioni su di esso",
  COMPLETED: 'Completato',
  PENDING: 'In attesa',
  'Replenishment saved successfully':
    'Missione di trasferimento salvata con successo',
  'Replenishment canceled successfully':
    'Missione di trasferimento annullata con successo',
  'View saved successfully': 'Vista salvata con successo',
  'View deleted successfully': 'Vista eliminata con successo',
  'Invalid credentials.': 'Username e/o password errati',
  'Reset categories': 'Reset categorie',
  'Picking-list saved successfully': 'Picking-list salvata con successo',
  'Picking-list deleted successfully': 'Picking-list eliminata con successo',
  'Picking-list printed successfully': 'Picking-list stampata con success',
  'Picking-list missions printed successfully':
    'Missioni picking-list stampate con successo',
  'Picking-list warehouse missing': 'Magazzino di prelievo non selezionato',
  'Quantity to be picked different from the number of total pieces':
    'Quantità da prelevare diversa dal numero di pezzi totali',
  'Multiple orders with the same reference':
    'Sono presenti più ordini con lo stesso riferimento',
  'Orders to pick not available': 'Non ci sono ordini prelevabili',
  'Picking list with more than 10 orders':
    'Picking list per ordine con più di 10 ordini',
  'You are about to delete the picking-list <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare la picking-list <strong>%s</strong>. Procedere all'eliminazione?",
  'Delete picking-list': 'Elimina picking-list',
  'Picking-list partial': 'Picking-list parziale',
  NOT_FOUND: 'Elemento non trovato',
  'User view not found.': 'Vista personalizzata non trovata.',
  'Not enough on-hand quantity.':
    'Non è possibile scaricare una quantità maggiore alla giacenza disponibile.',
  'Unable to decrement this batch': 'Non è possibile scaricare questo lotto.',
  BAD_REQUEST: 'Richiesta non accettata',
  'This goods return was updated by another user.':
    'Questo reso è stato aggiornato da un altro utente. Ricaricalo per poterlo modificare.',
  'Carrier not found.': 'Corriere non trovato.',
  'This packing list is closed.': 'La packing-list è chiusa.',
  'This Order was updated by another User.':
    "Quest'ordine è stato aggiornato da un altro utente. Ricaricalo per poterlo modificare.",
  'Orders management': 'Gestione ordini',
  'Warehouse address': 'Indirizzo magazzino',
  'Picking list with an empty order': 'Picking-list con un ordine senza righe',
  'Delete warehouse': 'Elimina magazzino',
  'You are about to delete the warehouse <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare il magazzino <strong>%s</strong>. Procedere all'eliminazione?",
  'Delete area': 'Elimina area',
  'You are about to delete the area <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare l'area <strong>%s</strong>. Procedere all'eliminazione?",
  'Delete model': 'Elimina modello',
  'You are about to delete the model <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare il modello <strong>%s</strong>. Procedere all'eliminazione?",
  CONFLICT: 'Conflitto',
  'Another packing attempt was performed by another User. Please wait 2 minutes before retry.':
    'Etichetta ordine stampata da poco. Attendi 2 minuti prima di procedere.',
  'Too many orders': 'Troppi ordini',
  'User already logged': 'Utente già loggato',
  'An active session already exists for this user. Proceed anyway?':
    'Esiste già una sessione attiva per questo utente. Procedere comunque?',
  Submit: 'Invio',
  'Password changed successfully': 'Password modificata con successo',
  'Password resetted successfully': 'Password resettata con success',
  'You will shortly receive an email with your new temporary password.':
    "A breve riceverai un'email con una nuova password temporanea.",
  'Sessione expired': 'Sessione scaduta',
  'Please log in again to continue.':
    "Effettua l'accesso per poter continuare.",
  'Settings saved successfully': 'Impostazioni salvate con successo',
  'Welcome!': 'Benvenuto!',
  'Tenant selected successfully': 'OrderPod è a tua disposizione',
  'Profile saved successfully': 'Profilo salvato con successo',
  'Available actions': 'Azioni disponibili',
  'Reload brands': 'Ricarica i brand',
  'Delete brand': 'Elimina brand',
  'Delete customer': 'Elimina cliente',
  'You are about to delete the brand <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare il brand <strong>%s</strong>. Procedere all'eliminazione?",
  'You are about to delete the customer <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare il cliente <strong>%s</strong>. Procedere all'eliminazione?",
  'Customer saved successfully': 'Cliente salvato con successo',
  'users selected': 'utenti selezionati',
  'User saved successfully': 'Utente salvato con successo',
  'Delete user': 'Elimina utente',
  'You are about to delete the user <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare l'utente <strong>%s</strong>. Procedere all'eliminazione?",
  'User deleted successfully': 'Utente eliminato con successo',
  'Eject user': 'Espelli utente',
  'You are about to eject the user <strong>%s</strong>. This user will no longer be able to access your tenant. Proceed with ejection?':
    "Stai per espellere l'utente <strong>%s</strong>. Questo utente non potrà più accedere al tuo tenant. Procedere all'espulsione?",
  'User ejected successfully': 'Utente espulso con successo',
  'Invite users': 'Invita utenti',
  'User invited successfully': 'Utente invitato con successo',
  'Manage roles': 'Gestisci ruoli',
  'Roles updated successfully': 'Ruoli aggiornati con successo',
  'Delete role': 'Elimina ruolo',
  'You are about to delete the role <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare il ruolo <strong>%s</strong>. Procedere all'eliminazione?",
  'Token created': 'Token creato',
  'API Token created successfully, and copied to memory.\nIt will no longer be visible afterwards':
    'Token API creato con successo, e copiato in memoria.\nSuccessivamente non sarà più visibile',
  'Token deleted successfully': 'Token eliminato con successo',
  'Goods return deleted successfully': 'Reso eliminato con successo',
  'Password updated successfully': 'Password aggiornata con successo',
  'Delete bot': 'Elimina integrazione',
  'You are about to delete the bot <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare l'integrazione <strong>%s</strong>. Procedere all'eliminazione?",
  'Goods return management': 'Gestione reso',
  'Goods returns': 'Gestione resi',
  'Reload users': 'Ricarica utenti',
  'Invite users in your current tenant': 'Invita degli utenti nel tuo tenant',
  'Manage roles of the selected users':
    'Gestisci i ruoli degli utenti selezionati',
  'Picking-list already started': 'Picking-list già iniziata',
  'Picking-list <strong>%s</strong> already started by <strong>%s</strong>. Proceed with packing?':
    "Picking-list <strong>%s</strong> già iniziata da <strong>%s</strong>. Procedere all'imballo?",
  'Reload categories': 'Ricarica categorie',
  'You are about to delete the channel <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare il canale <strong>%s</strong>. Procedere all'eliminazione?",
  'Delete channel': 'Elimina canale di vendita',
  'Category not found.': 'Categoria non trovata.',
  'Orders by channel': 'Ordini per canale',
  'Orders by status': 'Ordini per stato',
  'Delete goods return': 'Elimina reso',
  'You are about to delete the goods return <strong>%s</strong>. Proceed with deletion?':
    "Stai per elminare il reso <strong>%s</strong>. Vuoi procedere con l'eliminazione?",
  From: 'Da',
  To: 'A',
  Configure: 'Configura',
  'Configure stats': 'Configura statistiche',
  'Reload stats': 'Ricarica statistiche',
  'Warehouse not found': 'Magazzino non trovato',
  'An error occurred trying to send this information':
    'Si è verificato un errore durante il tentativo di inviare queste informazioni',
  'Goods return updated successfully': 'Reso aggiornato con successo',
  'Goods return canceled successfully': 'Reso annullato con successo',
  'Goods return saved successfully': 'Reso salvato con successo',
  'Cancel goods return': 'Annulla reso',
  'The goods return will be permanently cancelled and it will no longer be possible to process it or make any type of modification':
    'Il reso verrà definitivamente annullato e non sarà più possibile evaderlo o effettuare alcun tipo di modifica',
  'Rows error': 'Errore righe',
  'Rows with all quantities set to zero cannot be accepted':
    'Le righe con tutte le quantità impostate a zero non sono accettate',
  'Attachment deleted successfully': 'Allegato eliminato con successo',
  'Attachment uploaded successfully': 'Allegato caricato con successo',
  'Order already associated with a goods return':
    'Ordine già associato ad un reso',
  'Goods return not found': 'Reso non trovato',
  Open: 'Apri',
  Error: 'Errore',
  'Only goods return in RETURNING status can be deleted':
    'Solo i resi in stato IN ATTESA possono essere eliminati',
  'Goods returns with attachments cannot be deleted':
    'I resi con degli allegati non possono essere eliminati',
  'More than one linked goods-return found': 'Trovato più di un reso collegato',
  'Arrival date': 'Data arrivo',
  'Arrival date missing': 'Data di arrivo mancante',
  'Delete rows': 'Elimina righe',
  'Are you sure you want to delete all rows from this order?':
    'Sei sicuro di voler eliminare tutte le righe da questo ordine?',
  '1 attached present': '1 allegato presente',
  ' attachments present': ' allegati presenti',
  'The selected column is already present':
    'La colonna selezionata è già presente',
  'Reload goods returns': 'Ricarica resi',
  'Upload failed': 'Caricamento fallito',
  'Duplicated file name': 'Nome file duplicato',
  'Import in progress': 'Import in lavorazione',
  'Requested updates will be available soon and you will receive a summary email':
    "Presto saranno disponibili gli aggiornamenti richiesti e riceverai un'email di riepilogo",
  'Reload replenishments': 'Ricarica missioni di trasferimento',
  'Cannot cancel replenishment with moved quantity greater than zero':
    'Impossibile annullare un trasferimento con quantità trasferita maggiore di zero',
  'Only replenishments in PENDING and PROCESSING status can be canceled':
    'Solo i trasferimenti in stato IN ATTESA e IN LAVORAZIONE possono essere annullati',
  'You are about to cancel the replenishment <strong>%s</strong>. Proceed with cancelation?':
    "Stai per annullare il trasferimento <strong>%s</strong>. Procedere all'annullamento?",
  'Cancel replenishment': 'Annulla trasferimento',
  'Item successfully copied': 'Elemento copiato con successo',
  'There are no': 'Non ci sono',
  'Create one in order to be able to carry out operations':
    'Creane uno per poter effettuare delle operazioni',
  'Create new': 'Crea nuovo',
  'matching your search parameters were found':
    'che corrispondono ai parametri di ricerca',
  '-No': 'Non sono stati trovati',
  Page: 'Pagina',
  of: 'di',
  elements: 'elementi',
  'Goods return search hint':
    'Rif.ordine, nome|indirizzo|email cliente, nome|sku prodotto',
  'Create new goods return': 'Crea nuovo reso',
  View: 'Visualizzazione',
  Number: 'Numero',
  Date: 'Data',
  'Order ref.': 'Rif. ordine',
  'Ref. order date': 'Rif. data ordine',
  Packages: 'Colli',
  'Billing address': 'Indirizzo di fatturazione',
  'Goods return date': 'Data reso',
  'Goods return date required': 'Data reso richiesta',
  'Warehouse arrival date': 'Data di arrivo a magazzino',
  'Goods return ref.': 'Rif. reso',
  'Warehouse required': 'Magazzino richiesto',
  'Sales channel': 'Canale di vendita',
  'Sales channel required': 'Canale di vendita richiesto',
  Reason: 'Causale',
  Tag: 'Tag',
  'Reference order': 'Ordine di riferimento',
  'Reinstatement order': 'Ordine di reintegro',
  'SKU or barcode': 'SKU o barcode',
  'Add products': 'Aggiungi prodotti',
  'Total returned qty': 'Totale qtà resa',
  pcs: 'pz',
  'Copy ret qty on scr': 'Copia qtà resa su inv',
  'Copy exp qty on ret': 'Copia qtà att su resa',
  'Copy ord qty on exp': 'Copia qtà ord su att',
  'Reset scr qty': 'Azzera qtà inv',
  'Reset ret qty': 'Azzera qtà resa',
  Created: 'Creato',
  Updated: 'Modificato',
  'VAT inclusive expenses / VAT': 'Spese i.c. / IVA',
  'VAT inclusive expenses': 'Spese i.c.',
  'VAT exempt expenses': 'Spese i.e.',
  'VAT exempt gift cost': 'Costo regalo i.e.',
  'VAT inclusive gift cost': 'Costo regalo i.c.',
  'Gift VAT': 'IVA regalo',
  'VAT exempt expenses / VAT': 'Spese i.e. / IVA',
  'VAT exempt shipping costs': 'Spese spedizione i.e.',
  'VAT exempt shipping costs required': 'Spese spedizione i.e. richieste',
  'VAT inclusive shipping costs': 'Spese spedizione i.c.',
  'VAT inclusive shipping costs required': 'Spese spedizione i.c. richieste',
  'Shipping taxes': 'Tasse spedizione',
  'Shipping taxes required': 'Tasse spedizione richieste',
  'Goods return cost': 'Costo reso',
  '< 0 charged to the customer': '< 0 a carico del cliente',
  'VAT inclusive cost / VAT': 'Costo i.c. / IVA',
  'VAT exempt cost / VAT': 'Costo i.e. / IVA',
  'VAT exempt goods return cost': 'Costo reso i.e.',
  'VAT exempt goods return cost required': 'Costo reso i.e.',
  'VAT inclusive goods return cost': 'Costo reso i.c.',
  'VAT inclusive goods return cost required': 'Costo reso i.c. richiesto',
  Amount: 'Importo',
  Payment: 'Pagamento',
  'Payment method': 'Metodo di pagamento',
  'Payment required': 'Pagamento richiesto',
  Refund: 'Rimborso',
  'Refund notes': 'Note rimborso',
  Credit: 'Credito',
  'Credit notes': 'Note di credito',
  'VAT exempt subtotal': 'Subtotale i.e.',
  'VAT exempt cod amount': 'Costo contrassegno i.e.',
  'VAT inclusive cod amount': 'Costo contrassegno i.c.',
  Subtotal: 'Subtotale',
  'VAT inclusive subtotal': 'Subtotale i.c.',
  Taxes: 'Tasse',
  'VAT exempt shipping': 'Spedizione i.e.',
  Shipping: 'Spedizione',
  'VAT inclusive shipping': 'Spedizione i.c.',
  'Shipping VAT': 'IVA Spedizione',
  'VAT exempt cost': 'Costo i.e.',
  Cost: 'Costo',
  'VAT inclusive cost': 'Costo i.c.',
  'Cost VAT': 'IVA Costo',
  Total: 'Totale',
  'Incoming goods returns': 'Resi in rientro',
  'Received plural': 'Ricevuti',
  'Received goods returns': 'Resi ricevuti',
  Closed: 'Chiusi',
  'Closed goods returns': 'Resi chiusi',
  'Canceled plural': 'Annullati',
  'Canceled goods returns': 'Resi annullati',
  'Brand name': 'Nome brand',
  'Create new brand': 'Crea un nuovo brand',
  'goods returns selected': 'resi selezionati',
  'brands selected': 'brand selezionati',
  Brand: 'Brand',
  'Brand required': 'Brand richiesto',
  'Brands required': 'Brand richiesti',
  'Required data for brand management and structure':
    'Dati necessari per la struttura e la gestione del brand',
  'Brand name required': 'Nome brand richiesto',
  'Sales channels': 'Canali di vendita',
  'Management of brand-related sales channels':
    'Gestione dei canali di vendita collegati al brand',
  '* Mandatory fields': '* Campi obbligatori',
  Replenishment: 'Missione di trasferimento',
  Replenishments: 'Missioni di trasferimento',
  'replenishments selected': 'missioni di trasferimento selezionate',
  'Filters enabled': 'Filtri attivi',
  'Create new replenishment': 'Crea nuova missione di trasferimento',
  'Num.': 'Num.',
  'Product transfer data': 'Dati trasferimento prodotto',
  'Data necessary for the product transfer':
    'Dati necessari per il trasferimento di un prodotto',
  Product: 'Prodotto',
  'Product to transfer (SKU or Barcode)':
    'Prodotto da trasferire (SKU o Barcode)',
  'Product required': 'Prodotto richiesto',
  'Reference warehouse': 'Magazzino di riferimento',
  Source: 'Sorgente',
  'Source location': 'Ubicazione sorgente',
  'Destination location': 'Ubicazione destinazione',
  Destination: 'Destinazione',
  'Product transfer configuration': 'Configurazione trasferimento prodotto',
  'Required quantity': 'Quantità richiesta',
  Priority: 'Priorità',
  'Are you sure you want to delete the invoice <strong>%s</strong>?':
    'Sei sicuro di voler eliminare la fattura <strong>%s</strong>?',
  'Delete invoice': 'Elimina fattura',
  'Invoice deleted successfully': 'Fattura eliminata con successo',
  'Invoice saved successfully': 'Fattura salvata con successo',
  'invoices selected': 'fatture selezionate',
  'Reload invoices': 'Ricarica fatture',
  'Invoice date': 'Data fattura',
  'Invoice date required': 'Data fattura richiesta',
  'Invoice ref.': 'Rif. fattura',
  'Order ref. date': 'Rif. data ordine',
  'Type required': 'Tipologia richiesta',
  'Invoice type': 'Tipologia fattura',
  'Currency required': 'Valuta richiesta',
  '* Select a type of recipient': '* Seleziona una tipologia di destinatario',
  'The shipping address has more than 35 characters':
    "L'indirizzo di spedizione supera i 35 caratteri",
  'The selected carrier may refuse the shipment':
    'Il corriere selezionato potrebbe rifiutare la spedizione',
  'Shipping address': 'Indirizzo di spedizione',
  'Shipping address 2': 'Indirizzo di spedizione 2',
  'Shipping addresses': 'Indirizzi di spedizione',
  'Additional info': 'Informazioni aggiuntive',
  'Additional expenses and transport': 'Spese accessorie e trasporto',
  Transport: 'Trasporto',
  'Transport required': 'Trasporto richiesto',
  Flag: 'Flag',
  Paid: 'Pagato',
  Exported: 'Esportato',
  'Invoice alert': 'Alert fattura',
  Notes: 'Note',
  Internal: 'Interne',
  Payments: 'Pagamenti',
  Promotions: 'Promozioni',
  'Cash on delivery': 'Contrassegno',
  'Cash on delivery amounts': 'Importi contrassegno',
  'Total amount': 'Importo totale',
  'Cash on delivery min amount: €1': 'Importo contrassegno minimo: €1',
  'Amount required': 'Importo richiesto',
  'Shipping cost': 'Costo spedizione',
  'Simple product': 'Prodotto semplice',
  DRAFTED: 'Bozza',
  Drafted: 'Bozza',
  'DOES NOT commit the quantities in stock and is not visible for shipping management':
    'NON impegna le quantità a magazzino e non è visibile per la gestione della spedizione',
  'Supplier order': 'Ordine fornitore',
  'Supplier order search hint': 'Rif. ordine, nome|sku prodotto',
  'supplier orders selected': 'ordini fornitore selezionati',
  'Reload supplier orders': 'Ricarica ordini fornitore',
  'Create new supplier order': 'Crea nuovo ordine fornitore',
  'Supplier order closed successfully': 'Ordine fornitore chiuso con successo',
  'Delivery date': 'Data di consegna',
  'Date required': 'Data richiesta',
  'Supplier required': 'Fornitore richiesto',
  'Suppliers required': 'Fornitori richiesti',
  Suppliers: 'Fornitori',
  'Suppliers SKU': 'SKU Fornitori',
  'Order ref. required': 'Rif. ordine richiesto',
  'Ref. order date required': 'Rif. data ordine richiesta',
  Order: 'Ordine',
  Partial: 'Parziale',
  PARTIAL: 'PARZIALE',
  'Add requirement': 'Aggiungi fabbisogno',
  'Download production file': 'Scarica file produzione',
  Attachments: 'Allegati',
  'Delete order': 'Elimina ordine',
  'Cancel order': 'Annulla ordine',
  'Close order': 'Chiudi ordine',
  'View visible in catalog': 'Visualizza visibili in catalogo',
  'View in catalog': 'Visualizza in catalogo',
  'Print summary': 'Stampa riepilogo',
  'Print not available': 'Stampa non disponibile',
  'Download summary': 'Scarica riepilogo',
  'Product not assigned to any goods receive':
    'Prodotto non assegnato ad alcun arrivo merce',
  'Supplier orders with attachments cannot be deleted':
    'Gli ordini fornitore con degli allegati non possono essere eliminati',
  'Supplier order canceled successfully':
    'Ordine fornitore annullato con successo',
  'Supplier order deleted successfully':
    'Ordine fornitore eliminato con successo',
  'Supplier order not found': 'Ordine fornitore non trovato',
  'Supplier order printed': 'Ordine fornitore stampato',
  'Supplier order updated successfully':
    'Ordine fornitore aggiornato con successo',
  'Supplier order saved successfully': 'Ordine fornitore salvato con successo',
  'Cancel supplier order': 'Annulla ordine fornitore',
  'The supplier order will be permanently cancelled and it will no longer be possible to process it or make any type of modification':
    "L'ordine fornitore verrà definitivamente annullato e non sarà più possibile evaderlo o effettuare alcun tipo di modifica",
  'You are about to delete the supplier order <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare l'ordine fornitore <strong>%s</strong>. Procedere all'eliminazione?",
  'No product to be ordered': 'Nessun prodotto da ordinare',
  'You selected': 'Hai selezionato',
  rows: 'righe',
  products: 'prodotti',
  'Order products': 'Prodotti ordine',
  Reset: 'Reset',
  Select: 'Seleziona',
  Yes: 'Sì',
  No: 'No',
  'All-s': 'Tutti',
  Edit: 'Modifica',
  'No result found': 'Nessun risultato trovato',
  'Try to reset or modify the search':
    'Riprova resettando o modificando la ricerca',
  'Reload printers': 'Ricarica stampanti',
  "Oops, it looks like it's not possible to use printers right now":
    'Ops, sembra non sia possibile utilizzare le stampanti',
  'Check that you have access to printers and that PrintNode is configured correctly':
    'Controlla che tu abbia accesso alle stampanti e che sia configurato correttamente PrintNode',
  Printer: 'Stampante',
  'Printer required': 'Stampante richiesta',
  Print: 'Stampa',
  on: 'su',
  Station: 'Postazione',
  'Select station': 'Seleziona postazione',
  'Select printer': 'Seleziona stampante',
  'Quantity required': 'Quantità richiesta',
  Quantity: 'Quantità',
  Set: 'Imposta',
  'Set quantity': 'Imposta quantità',
  'Station required': 'Postazione richiesta',
  'You are about to delete the tag <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare il tag <strong>%s</strong>. Procedere all'eliminazione?",
  'Reload tags': 'Ricarica tag',
  'Create new tag': 'Crea nuovo tag',
  'tags selected': 'tag selezionati',
  'Tag name': 'Nome tag',
  'Tag name required': 'Nome tag richiesto',
  'Select type': 'Seleziona tipologia',
  Color: 'Colore',
  'Delete tag': 'Elimina tag',
  'Suppliers search hint': 'Rag. sociale, indirizzo, email, codice',
  'suppliers selected': 'fornitori selezionati',
  'Reload suppliers': 'Ricarica fornitori',
  'Create new supplier': 'Crea nuovo fornitore',
  'Data required for the structure and management of the supplier':
    'Dati necessari per la struttura e la gestione del fornitore',
  'Supplier code': 'Codice fornitore',
  'Supplier code required': 'Codice fornitore richiesto',
  'Value is not unique': 'Il valore non è univoco',
  'Code not unique': 'Codice non univoco',
  Alias: 'Alias',
  'Company data': 'Dati aziendali',
  'Supplier company data': 'Dati aziendali del fornitore',
  'Business name': 'Ragione sociale',
  'Business name required': 'Ragione sociale richiesta',
  'Address 2': 'Indirizzo 2',
  Address: 'Indirizzo',
  City: 'Città',
  'Postal code': 'CAP',
  'City required': 'Città richiesta',
  'Postal code required': 'CAP richiesto',
  Country: 'Stato',
  Countries: 'Stati',
  'Country required': 'Stato richiesto',
  'Countries required': 'Stati richiesti',
  Province: 'Provincia',
  Provinces: 'Province',
  'Province required': 'Provincia richiesta',
  'Provinces required': 'Province richieste',
  'VAT number': 'Partita IVA',
  'Tax ID code': 'Codice fiscale',
  Contacts: 'Contatti',
  'Info to contact the supplier': 'Informazioni per contattare il fornitore',
  Surname: 'Cognome',
  'Surname required': 'Cognome richiesto',
  Phone: 'Telefono',
  Email: 'Email',
  'Supplier deleted successfully': 'Fornitore eliminato con successo',
  'Supplier saved successfully': 'Fornitore salvato con successo',
  'Delete supplier': 'Elimina fornitore',
  'You are about to delete the supplier <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare il fornitore <strong>%s</strong>. Procedere all'eliminazione?",
  'Manufacturer deleted successfully': 'Produttore eliminato con successo',
  'Manufacturer saved successfully': 'Produttore salvato con successo',
  'You are about to delete the manufacturer <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare il produttore <strong>%s</strong>. Procedere all'eliminazione?",
  Manufacturers: 'Produttori',
  Manufacturer: 'Produttore',
  'Manufacturer required': 'Produttore richiesto',
  'Manufacturers required': 'Produttori richiesti',
  'manufacturers selected': 'produttori selezionati',
  'Reload manufacturers': 'Ricarica produttori',
  'Create new manufacturer': 'Crea nuovo produttore',
  'Required data for manufacturer management and structure':
    'Dati necessari per la struttura e la gestione del produttore',
  'Manufacturer name required': 'Nome produttore richiesto',
  'Manufacturer name': 'Nome produttore',
  "Manufacturer's external reference": 'Riferimento esterno produttore',
  'Carrier required': 'Corriere richiesto',
  'Carriers required': 'Corrieri richiesti',
  'Channel required': 'Canale richiesto',
  Channel: 'Canale',
  'Banner deleted successfully': 'Insegna eliminata con successo',
  'Banner saved successfully': 'Insegna salvata con successo',
  'You are about to delete the banner <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare l'insegna <strong>%s</strong>. Procedere all'eliminazione?",
  Banners: 'Insegne',
  'banners selected': 'insegne selezionate',
  'Reload banners': 'Ricarica insegne',
  'Create new banner': 'Crea nuova insegna',
  'Banner required': 'Insegna richiesta',
  'Banner not found': 'Insegna non trovata',
  'Attachment not found': 'Allegato non trovato',
  'Required data for banner management and structure':
    "Dati necessari per la struttura e la gestione dell'insegna",
  Photo: 'Foto',
  'Number / Receipt': 'Numero / Scontrino',
  Receipt: 'Scontrino',
  Consignee: 'Nominativo',
  banner: 'insegna',
  Banner: 'Insegna',
  banners: 'insegne',
  brand: 'brand',
  brands: 'brands',
  goodsReturn: 'reso',
  goodsReturns: 'resi',
  payments: 'pagamenti',
  payment: 'pagamento',
  promotions: 'promozioni',
  promotion: 'promozione',
  Promotion: 'Promozione',
  Description: 'Descrizione',
  'goods-return': 'reso',
  'invoice-rows': 'righe-fattura',
  invoice: 'fattura',
  SKU: 'SKU',
  Qty: 'Qtà',
  Single: 'Unità',
  'VAT inclusive': 'i.c.',
  'VAT exempt': 'i.e.',
  Discount: 'Sconto',
  '% VAT tax': '% IVA',
  'VAT tax tot.': 'Tot. IVA',
  'Row tot.': 'Tot. riga',
  invoices: 'fatture',
  Invoices: 'Fatture',
  'Invoice #': '# fattura',
  'Date ref.': 'Rif. data',
  'Billing add.': 'Ind. fatturazione',
  'Shipping add.': 'Ind. destinazione',
  manufacturers: 'produttori',
  manufacturer: 'produttore',
  printers: 'stampanti',
  printer: 'stampante',
  ID: 'ID',
  'Computer name': 'Nome computer',
  'Creation date': 'Data creazione',
  replenishments: 'trasferimenti',
  replenishment: 'trasferimento',
  'Replenishment #': '# trasferimento',
  Origin: 'Origine',
  Status: 'Stato',
  'Required qty': 'Qtà richiesta',
  'Transferred qty': 'Qtà trasferita',
  supplier_order: 'ordine_fornitore',
  supplier_orders: 'ordini_fornitore',
  'Supplier ref.': 'Rif. fornitore',
  Ordered: 'Ordinata',
  Assigned: 'Assegnata',
  'VAT inclusive row tot.': 'Tot. riga i.c.',
  'VAT exempt single': 'Unità i.e.',
  'VAT inclusive single': 'Unità i.c.',
  'VAT inclusive discount': 'Sconto i.c.',
  'VAT exempt discount': 'Sconto i.e.',
  '% discount': 'Sconto %',
  'VAT exempt row tot.': 'Tot. riga i.e.',
  Price: 'Prezzo',
  'Purchase price': "Prezzo d'acquisto",
  'Listing price': 'Prezzo di listino',
  'Select orders': 'Seleziona ordini',
  'Select order': 'Seleziona ordine',
  'Order #': '# ordine',
  'Rows qty': 'Qtà righe',
  'Pieces qty': 'Qtà pezzi',
  'Supplier SKU': 'SKU Fornitore',
  suppliers: 'fornitori',
  supplier: 'fornitore',
  Code: 'Codice',
  Street: 'Via',
  State: 'Stato',
  tags: 'tags',
  tag: 'tag',
  'Refund date': 'Data rimborso',
  'Goods return #': '# reso',
  'Destination state': 'Stato destinazione',
  'Ordered pcs': 'Pz ordinati',
  'Returned pcs': 'Pz resi',
  'Scrapped pcs': 'Pz invendibili',
  'Reinstatement ord. #': '# ord. reintegro',
  'Reinstatement ord. ref.': 'Rif. ord. reintegro',
  'Reinstatement ord. date ref.': 'Rif. data ord. reintegro',
  'Reference ord. #': '# ord. riferimento',
  'Reference ord. ref.': 'Rif. ord. riferimento',
  'Reference ord. date ref.': 'Rif. data ord. riferimento',
  'Total rows': 'Righe totali',
  'Returned rows': 'Righe rese',
  'Shipped to': 'Spedito a',
  Shipped: 'Spedito',
  Delivered: 'Consegnato',
  'The carrier delivered this order': 'Ordine consegnato dal corriere',
  'Order handed over to the carrier': 'Ordine affidato al corriere',
  'Billed to': 'Fatturato a',
  'Date/Hour creation': 'Data/Ora creazione',
  'Expected delivery date': 'Data consegna prevista',
  Rows: 'Righe',
  Pieces: 'Pezzi',
  '% Ord./Rec.': '% Ord./Ric.',
  'Customer not found': 'Cliente non trovato',
  Customers: 'Clienti',
  'Customer search hint': 'Nome, rag. sociale, indirizzo, email, codice',
  'customers selected': 'clienti selezionati',
  ZIP: 'CAP',
  'Catalog list': 'Listino',
  References: 'Riferimenti',
  customers: 'clienti',
  customer: 'cliente',
  Default: 'Default',
  shipping_address: 'indirizzo_di_spedizione',
  'Customer shipping address data':
    "Dati relativi all'indirizzo di spedizione del cliente",
  'Address required': 'Indirizzo richiesto',
  'ZIP required': 'CAP richiesto',
  'Customer contacts data': 'Dati relativi ai contatti del cliente',
  'Required data for customer management and structure':
    'Dati necessari per la struttura e la gestione del cliente',
  'Customer specific references': 'Riferimenti specifici del cliente',
  'Code / Fidelity': 'Codice / Fidelity',
  Agent: 'Agente',
  "Customer's billing address data":
    "Dati relativi all'indirizzo di fatturazione del cliente",
  'SDI Code': 'Codice SDI',
  'Customer contact methods': 'Metodi di contatto del cliente',
  'Certified email': 'PEC',
  Customer: 'Cliente',
  'Add new address': 'Aggiungi nuovo indirizzo',
  'Address not found': 'Indirizzo non trovato',
  'Download the XLS file of the selected items':
    'Scarica file XLS degli elementi selezionati',
  'Edit view': 'Modifica vista',
  'Manage through file': 'Gestisci tramite file',
  Invoice: 'Fattura',
  'Upload banner image': "Carica l'immagine dell'insegna",
  'Upload replenihsments XLS file':
    'Carica il file XLS delle missioni di trasferimento',
  'Upload orders XLS file': 'Carica il file XLS degli ordini',
  'Email for report': 'Email per resoconto',
  'Generate file': 'Genera file',
  'Upload the XLS file with the supplier order rows':
    "Carica il file XLS con le righe dell'ordine",
  'Download example file': "Scarica il file d'esempio",
  task: 'attività',
  tasks: 'attività',
  'Reload tasks': 'Ricarica task',
  'Raw execution': 'Esecuzione raw',
  'Goods return waiting for the goods': 'Reso in attesa della merce',
  'Goods return received by the relevant warehouse':
    'Reso ricevuto dal magazzino di competenza',
  'Goods return management ended': 'Gestione del reso terminata',
  'Goods return canceled': 'Reso annullato',
  'Mark as received': 'Segna come ricevuto',
  'Mark as pending': 'Segna come in attesa',
  'Close goods return': 'Chiudi il reso',
  'Revert to manageable': 'Rimetti in lavorazione',
  'Credit note': 'Nota di credito',
  'Receipt fiscal code': 'Scontrino con CF',
  'Goods return': 'Reso',
  Generic: 'Generico',
  High: 'Alta',
  Medium: 'Media',
  Low: 'Bassa',
  'Replenishment waiting for operator':
    "Trasferimento in attesa dell'operatore",
  'Replenishment being managed by an operator':
    "Trasferimento in lavorazione da parte dell'operatore",
  'Replenishment completed by an operator':
    "Trasferimento completato da parte dell'operatore",
  'Replenishment canceled': 'Trasferimento annullato',
  'Draft supplier order, ready to be confirmed':
    'Ordine fornitore in bozza, pronto per essere confermato',
  'Supplier order ready to be added to a goods receive':
    'Ordine pronto per essere inserito in un arrivo merce',
  'One or more rows of this supplier order have been assigned to a goods receive. Waiting for the goods to be received':
    "Una o più righe dell'ordine fornitore sono state assegnate ad un arrivo merce. In attesa del riscontro merce",
  'One or more rows of this supplier order have been received and loaded into the warehouse':
    "Una o più righe dell'ordine fornitore sono state riscontrate e caricate a magazzino",
  'Supplier order is definitively closed. All incoming goods assigned to the order rows have been processed':
    "Ordine fornitore definitivamente chiuso. Tutti gli eventuali arrivi merce assegnati alle righe d'ordine sono stati processati",
  'Supplier order canceled': 'Ordine fornitore annullato',
  'Confirm order': 'Conferma ordine',
  'Ord. q.': 'Q. ord.',
  'Exp. q.': 'Q. att.',
  'Ret. q.': 'Q. resa',
  'Scr. q.': 'Q. inv.',
  'Assigned quantity': 'Quantità assegnata',
  'Received quantity': 'Quantità ricevuta',
  'Save the new view': 'Salva la nuova vista',
  'Create a new view with the current settings':
    'Crea una nuova vista con le impostazioni attuali',
  'Save current view': 'Salva la vista corrente',
  'Deselect the view as default': 'Deseleziona la vista come predefinita',
  'Set the view as default': 'Imposta la vista come predefinita',
  'New personal view': 'Nuova vista personale',
  edited: 'modificata',
  'View edited': 'Vista modificata',
  'Select a view': 'Seleziona una vista',
  'Set selected filters': 'Imposta i filtri selezionati',
  or: 'oppure',
  'There are no configured filters': 'Non sono presenti filtri configurati',
  'Set filter': 'Imposta filtro',
  'Remove filter': 'Rimuovi filtro',
  'Select date': 'Seleziona data',
  Users: 'Utenti',
  Username: 'Username',
  Roles: 'Ruoli',
  Guest: 'Ospite',
  users: 'utenti',
  user: 'utente',
  'Create new user': 'Crea nuovo utente',
  'New user': 'Nuovo utente',
  'Edit user': 'Modifica utente',
  'Personal info': 'Informazioni personali',
  'User personal info': "Informazioni personali dell'utente",
  Credentials: 'Credenziali',
  'Username and password needed to log in':
    'Username e password richiesti per effettuare il login',
  'Username already used': 'Username già utilizzato',
  'Username required': 'Username richiesto',
  'Minimum length is ': 'La lunghezza minima è ',
  ' characters': ' caratteri',
  Password: 'Password',
  'Old password': 'Vecchia password',
  'New password': 'Nuova password',
  'Change password': 'Modifica la password',
  'Password required': 'Password richiesta',
  'Confirm password': 'Conferma password',
  'Insert password again': 'Inserisci nuovamente la password',
  'Values do not match': 'I valori non corrispondono',
  Configuration: 'Configurazione',
  User: 'Utente',
  Integration: 'Integrazione',
  Authorizations: 'Permessi',
  'Integration identification data':
    "Dati di identificazione dell'integrazione",
  'Unique code': 'Codice univoco',
  'Code required': 'Codice richiesto',
  'Code already used': 'Codice già utilizzato',
  'Name required': 'Nome richiesto',
  'Roles management': 'Gestione ruoli',
  'Roles and allowed accesses management':
    'Gestione ruoli e accessi consentiti',
  'Roles and users allowed accesses configuration':
    "Configurazione dei ruoli e degli accessi consentiti all'utente",
  'Configuration fo the roles assigned to the integration':
    "Configurazione dei ruoli assegnati all'integrazione",
  'User roles': 'Ruoli utente',
  'Integration roles': 'Ruoli integrazione',
  'Edit user roles': 'Modifica ruoli utente',
  'Assign roles to the user': "Assegna ruoli all'utente",
  'Allowed accesses': 'Accessi consentiti',
  Web: 'Web',
  'App mobile': 'App mobile',
  'Warning!': 'Attenzione!',
  "Without allowed accesses the user won't be able to access OrderPod":
    "Senza un accesso consentito l'utente non potrà accedere ad OrderPod",
  'Management of the authorizations assigned to the user':
    "Gestione dei permessi assegnati all'utente",
  'Management of the authorizations assigned to the integration':
    "Gestione dei permessi assegnati all'integrazione",
  'Roles required': 'Ruoli richiesti',
  'Tenant not found': 'Tenant non trovato',
  'Prices view': 'Visualizzazione prezzi',
  'Prices view settings': 'Impostazioni di visualizzazione dei prezzi',
  'Prices with VAT': 'Prezzi IVA inclusa',
  'VAT included': 'IVA inclusa',
  'Percentage discount': 'Sconto percentuale',
  'Picking list settings within RePod app':
    "Impostazioni per le picking list nell'app RePod",
  'Auto location confirm': 'Conferma ubicazione automatica',
  'Info following mission': 'Info prossima missione',
  'Goods receives settings within RePod app':
    "Impostazioni per gli arrivi merce nell'app RePod",
  'Package counter': 'Contatore per confezioni',
  'Home customization': 'Personalizzazione home',
  'Home sections configuration for OrderPod and RePod':
    'Configurazione delle sezioni della pagina iniziale di OrderPod e RePod',
  Module: 'Modulo',
  'Visible states': 'Stati visibili',
  'Non-customized home': 'Home non personalizzata',
  Customize: 'Personalizza',
  'RePod configuration': 'Configurazione RePod',
  'General settings for using RePod app':
    "Impostazioni generali per l'utilizzo dell'applicazione RePod",
  'Keep screen active': 'Mantieni schermo attivo',
  'Full screen': 'Full screen',
  'Notifications volume': 'Volume notifiche',
  'Device volume': 'Volume dispositivo',
  'User configuration': 'Configurazione utente',
  'OrderPod and RePod user customizations':
    "Personalizzazioni di OrderPod e RePod per l'utente",
  'Customizations not enabled': 'Personalizzazioni non abilitate',
  Enable: 'Abilita',
  'API token management': 'Gestione token API',
  'Token management for the direct usage of OrderPod API':
    "Gestione dei token per l'utilizzo diretto delle API di OrderPod",
  'Create new token': 'Crea nuovo token',
  'There are no tokens configured': 'Non ci sono token configurati',
  Signature: 'Firma',
  tokens: 'token',
  token: 'token',
  Printers: 'Stampanti',
  'Printers configuration for the current user within the current tenant':
    "Configurazione delle stampanti predefinite dell'utente per il tenant corrente",
  'Printing enabled': 'Abilitazione stampa',
  'Labels printer': 'Stampante etichette',
  'A4 printer': 'Stampante A4',
  'Bluetooth printer': 'Stampante bluetooth',
  'Bluetooth printer name': 'Nome stampante Bluetooth',
  'Printer MAC address': 'Indirizzo MAC stampante',
  'Remove printer': 'Rimuovi stampante',
  Remove: 'Rimuovi',
  'Bluetooth printer not configured': 'Stampante Bluetooth non configurata',
  'Default warehouse configuration for the current user within the current tenant':
    "Configurazione del magazzino predefinito per l'utente per il tenant corrente",
  'Inherited authorization': 'Permesso ereditato',
  'Pickup point': 'Pickup point',
  Preset: 'Preset',
  'Role saved successfully': 'Ruolo salvato con successo',
  'There was an error trying to save permissions':
    'Si è verificato un errore nel salvare i permessi',
  Role: 'Ruolo',
  'Edit role': 'Modifica ruolo',
  'Role deleted successfully': 'Ruolo eliminato con successo',
  'Update password': 'Aggiorna password',
  'Set new password': 'Imposta nuova password',
  'Minimum 8 characters required': 'Minimo 8 caratteri richiesti',
  'Assign or remove roles to': 'Assegna o rimuovi ruoli a',
  Assign: 'Assegna',
  'Expel user': 'Espelli utente',
  'New role': 'Nuovo ruolo',
  'Create new role': 'Crea nuovo ruolo',
  'Create new integration': 'Crea nuovo integrazione',
  Integrations: 'Integrazioni',
  'New integration': 'Nuova integrazione',
  'Reload customers': 'Ricarica clienti',
  'Create new customer': 'Crea nuovo cliente',
  'Invioces search hint': 'Rif. fattura, nome|email fatt., nome|sku prodotto',
  VAT: 'IVA',
  'Goods receive ref.': 'Rif. arrivo merce',
  'Refund amount': 'Importo rimborso',
  label: 'etichetta',
  summary: 'riepilogo',
  'You are about to delete the order <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare l'ordine <strong>%s</strong>. Procedere all'eliminazione?",
  'Order saved successfully': 'Ordine salvato con successo',
  'An error occurred while saving this order':
    'Si è verificato un errore nel salvare questo ordine',
  'Printers not found': 'Stampanti non trovate',
  'Order printed successfully': 'Ordine stampato con successo',
  'Shipment canceled successfully': 'Spedizione annullata con successo',
  'Shipment requested successfully': 'Spedizione richiesta con successo',
  'Shipment not found': 'Spedizione non trovata',
  'Print DDT': 'Stampa DDT',
  'Download DDT': 'Scarica DDT',
  'DDT printed successfully': 'DDT stampato con successo',
  'No label found for this order': "Nessuna etichetta trovata per quest'ordine",
  'Order duplicated successfully': 'Ordine duplicato con successo',
  'You are about to duplicate the order <strong>%s</strong>. Proceed?':
    "Stai per duplicare l'ordine <strong>%s</strong>. Procedere?",
  'Orders with attachments cannot be deleted':
    'Gli ordini con degli allegati non possono essere eliminati',
  'Upload Amazon orders TXT file': 'Carica il file TXT degli ordini Amazon',
  'Order deleted successfully': 'Ordine eliminato con successo',
  'No shipment in SHIPPED or REQUESTED status has been found':
    "Non è stata trovata nessuna spedizione nell'ordine in status SPEDITA o RICHIESTA",
  orders: 'ordini',
  order: 'ordine',
  'Order date': 'Data ordine',
  'External order ref.': 'Rif. ordine esterno',
  'Picked by': 'Prelevato da',
  Packed: 'Imballato',
  'Packed by': 'Imballato da',
  'Order ready to be handed over to the carrier':
    'Ordine pronto per essere affidato al corriere',
  'Billing name': 'Intestatario fattura',
  'Billing address 2': 'Indirizzo di fatturazione 2',
  'Billing add. city': 'Città di fatturazione',
  'Billing add. province': 'Provincia di fatturazione',
  'Billing add. postal code': 'CAP di fatturazione',
  'Billing add. country': 'Stato di fatturazione',
  'Billing add. phone': 'Telefono di fatturazione',
  'Billing add. email': 'Email di fatturazione',
  'Shipping name': 'Destinatario merce',
  'Shipping add. city': 'Città di destinazione',
  'Shipping add. country': 'Stato di destinazione',
  'Shipping add. email': 'Email di destinazione',
  'Shipping add. phone': 'Telefono di destinazione',
  'Shipping add. postal code': 'CAP di destinazione',
  'Shipping add. province': 'Provincia di destinazione',
  'Cash on delivery amount': 'Importo contrassegno',
  'Shipping date': 'Data spedizione',
  'Packing date': 'Data imballo',
  'Vol (cbm)': 'Vol (m³)',
  cbm: 'm³',
  'Estimated vol (cbm)': 'Vol stimato (m³)',
  'Estimated weight (kg)': 'Peso stimato (kg)',
  Group: 'Gruppo',
  'Packing notes': 'Note packing',
  Splitted: 'Diviso',
  Split: 'Dividi',
  Duplicated: 'Duplicato',
  Returned: 'Reso',
  Gift: 'Regalo',
  'Carrier notes': 'Note corriere',
  'EEC destination': 'Destinazione CEE',
  'Order search hint': 'Rif. ordine, nome|email dest., nome|sku prodotto',
  SHIPPED: 'Spedito',
  DELIVERED: 'Consegnato',
  DROPSHIPPED: 'Dropshipped',
  Dropshipped: 'Dropshipped',
  'The order is managed externally': "L'ordine è gestito esternamente",
  HANDED: 'Ritirato',
  Handed: 'Ritirato',
  'Mark as drafted': 'Metti in attesa',
  'Mark as delivered': 'Segna come consegnato',
  'Mark as shipped': 'Segna come spedito',
  'Mark as handed': 'Segna come ritirato',
  'Revert to confirmed': 'Riporta in confermato',
  'Order delivered by hand to the customer':
    'Ordine consegnato a mano al cliente',
  'orders selected': 'ordini selezionati',
  'Reload orders': 'Ricarica ordini',
  'Create new order': 'Crea nuovo ordine',
  'Add tag to the selected items': 'Aggiungi tag agli elementi selezionati',
  'Upload orders': 'Carica ordini',
  'Upload Amazon orders with TXT file': 'Carica ordini Amazon con file TXT',
  'Edit orders': 'Modifica ordini',
  'Orders evadibility': 'Evadibilità ordini',
  'Export Amazon shippings file': 'Esporta file spedizioni Amazon',
  'Export Amazon shippings': 'Esporta spedizioni Amazon',
  'Export requested successfully. You will receive it via email soon':
    'Esportazione richiesta con successo. La riceverai presto via email',
  'Start date': 'Data inizio',
  'Start date/time': 'Data/ora inizio',
  'Date/time': 'Data/ora',
  'End date': 'Data fine',
  'Search shipping ref.': 'Cerca rif. spedizione',
  'Search shipping reference': 'Cerca riferimento spezione',
  'Shipping ref.': 'Rif. spedizione',
  'Shipping ref. required': 'Rif. spedizione richiesto',
  Search: 'Cerca',
  Tags: 'Tag',
  'Tags required': 'Tag richiesti',
  'Orders tag': 'Tag ordini',
  'Set tag': 'Imposta tag',
  'Tags set successfully': 'Tag impostati con successo',
  'Tag saved successfully': 'Tag salvato con successo',
  'Tag deleted successfully': 'Tag eliminato con successo',
  'Split order': 'Dividi ordine',
  "Warning! The order total can't be negative":
    'Attenzione! Totale ordine non può essere negativo',
  'Discount total': 'Totale sconto',
  'Order total': 'Totale ordine',
  'Add order': 'Aggiungi ordine',
  'Selection limit reached. Deselect at least one item to continue':
    'Limite di selezione raggiunto. Deseleziona almeno un elemento per continuare',
  Alert: 'Alert',
  Coverage: 'Evadibilità',
  'Unusable order description':
    'Prodotti ubicati in UDC. Questi prodotti non verranno presi in considerazione per il prelievo',
  Weight: 'Peso',
  kg: 'kg',
  Volume: 'Volume',
  'With errors': 'Con errori',
  'Non-processable orders': 'Ordini non processabili',
  'Draft/Pending': 'Bozza/In attesa',
  'Waiting for a confirmation to be managed':
    'In attesa di conferma per essere gestiti',
  'To be picked up': 'Da prelevare',
  'Orders ready to be picked up': 'Ordini pronti per essere prelevati',
  'Being picked up': 'In prelievo',
  'Orders being managed': 'Ordini presi in carico',
  'To be packed': 'Da imballare',
  'Orders processed and waiting to be packed':
    'Ordini prelevati e in attesa di essere imballati',
  'To be shipped': 'Da spedire',
  'Orders ready to be handed to the carrier':
    'Ordini pronti per essere affidati al corriere',
  'Update completed': 'Aggiornamento terminato',
  'Field to update': 'Campo da aggiornare',
  'Update method': 'Metodo di aggiornamento',
  Method: 'Metodo',
  'Confirm update of %s orders': 'Conferma aggiornamento di %s ordini',
  "You're about to edit the field": 'Stai per modificare il campo',
  'of these orders': 'di questi ordini',
  'with the mode': 'in modalità',
  'The update is irreversible': "L'aggiornamento è irreversibile",
  Results: 'Risultati',
  'Update results': 'Risultati aggiornamento',
  'Export results': 'Esporta risultati',
  Result: 'Risultato',
  Detail: 'Dettaglio',
  Close: 'Chiudi',
  orders_updated: 'ordini_aggiornati',
  Unprocessable: 'Non evadibili',
  Partials: 'Parziali',
  'Assigned to PL': 'Assegnati a PL',
  Pickable: 'Prelevabili',
  'Stock (Ava)[Ord]{Inc}': 'Giac. (Dis)[Ord]{Arr}',
  Stock: 'Giacenza',
  Dropship: 'Dropship',
  order_coverage: 'evadibilità_ordine',
  'Expand all': 'Espandi tutto',
  'Reset filters': 'Reset filtri',
  'Collapse all': 'Chiudi tutto',
  Disable: 'Disabilita',
  'Show shared': 'Mostra condivise',
  Shared: 'Condivise',
  'Permissions updated successfully': 'Permessi aggiornati con successo',
  'Sellable products': 'Prodotti vendibili',
  'Unsellable products': 'Prodotti invendibili',
  'Ordered quantity': 'Quantità ordinata',
  'Expected quantity': 'Quantità attesa',
  'Returned quantity': 'Quantità resa',
  'Scrapped quantity': 'Quantità invendibile',
  'Update date': 'Data aggiornamento',
  'Order num.': 'Ordine num.',
  'Customer order': 'Ordine cliente',
  'Data required for the shipping of the customer order':
    "Dati necessari per la spedizione dell'ordine cliente",
  'Order shipping name': 'Destinatario',
  'Order shipping name required': 'Destinatario richiesto',
  'Shipping contacts': 'Contatti di spedizione',
  'Additional data needed for the shipping of the order':
    "Dati aggiuntivi utili per la spedizione dell'ordine cliente",
  'Search for an address or a name': 'Cerca un indirizzo o un nome',
  'Search an address': 'Cerca un indirizzo',
  'Address data': "Dati anagrafici dell'indirizzo",
  'Address contacts': "Contatti relativi all'indirizzo",
  'Add new customer and set': 'Inserisci nuovo cliente e imposta',
  'Transport costs': 'Spese trasporto',
  'Service required': 'Servizio richiesto',
  Service: 'Servizio',
  'Customs duties': 'Dazi doganali',
  'Tracking number': 'Numero tracking',
  'Open the tracking page': 'Apri la pagina di tracking',
  'No tracking page available for this carrier':
    'Nessuna pagina di tracking disponibile per questo corriere',
  'Shipment options': 'Opzioni spedizione',
  Insurance: 'Assicurazione',
  'Call before delivery': 'Preavviso telefonico',
  'Automatic carrier': 'Corriere automatico',
  Message: 'Messaggio',
  'Additional expenses': 'Spese accessorie',
  'Additional packages': 'Imballi aggiuntivi',
  'No packages': 'Nessun imballo presente',
  'Order packages': 'Imballi',
  'Package info': 'Informazioni imballo',
  'One or more values are negative': 'Uno o più valori sono negativi',
  'The cash on delivery amount (%s) is different from the order total amount (%s). Proceed?':
    "L'importo del contrassegno (%s) è diverso dal totale dell'ordine (%s). Procedere?",
  'No rows. Add products to this order':
    "Nessuna riga. Aggiungi prodotti a quest'ordine",
  'Billing address missing': 'Indirizzo di fatturazione mancante',
  'Shipping address missing': 'Indirizzo di spedizione mancante',
  'At least one product need to be picked in order to process this order':
    "È necessario prelevare almeno un prodotto per poter processare l'ordine",
  'Orders assigned to a picking list cannot be processed':
    'Non è possibile processare ordini assegnati a picking list',
  'Orders assigned to a bordereau cannot be processed':
    'Non è possibile processare ordini assegnati a bordereau',
  'Order assigned to unfinished packing lists cannot be modified':
    'Non è possibile modificare ordini assegnati a packing list non terminate',
  'Order canceled successfully': 'Ordine annullato con successo',
  'The order will be permanently cancelled and it will no longer be possible to process it or make any type of modification':
    "L'ordine verrà definitivamente annullato e non sarà più possibile evaderlo o effettuare alcun tipo di modifica",
  'For orders assigned to a picking list, the picking cannot be canceled':
    'Non è possibile resettare il prelievo ad ordini assegnati a picking list',
  'Order picking reset successfully': 'Picking ordine resettato con successo',
  'At least one invoice was found for this order that is about to be canceled. Do you want to delete all invoices?':
    "È stata trovata almeno una fattura per quest'ordine che sta per essere annullato. Vuoi eliminare tutte le fatture?",
  'Process order': 'Processa ordine',
  'Print label': 'Stampa etichetta',
  'Download label': 'Scarica etichetta',
  'Save packages': 'Salva imballi',
  'Product picked successfully': 'Prodotto prelevato con successo',
  'Order packed successfully': 'Ordine imballato con successo',
  'Order processed successfully': 'Ordine processato con successo',
  'Print sent successfully': 'Stampa inviata con successo',
  'Order splitted successfully': 'Ordine diviso con successo',
  'Discount applied': 'Sconto applicato',
  'By canceling the shipment, this order won\'t be put in "Processed" status. You will have to click on "Request shipment" in order to generate another label':
    'Annullando la spedizione, l\'ordine non viene più messo in stato "Processato". Dovrai cliccare sul pulsante "Richiedi spedizione" per rigenerare l\'etichetta',
  'The order alert was enabled, but this order is already being managed. If you want to stop the order, contact the customer service. Proceed?':
    "L'alert ordine è stato attivato, ma questo ordine è già stato preso in carico dal magazzino. Se vuoi fermare l'ordine, contatta il servizio clienti. Procedere?",
  order_label: 'etichetta_ordine',
  'There was an error trying to download some of the labels of this order':
    "Si è verificato un errore nello scaricare alcune delle etichette di quest'ordine",
  'Labels downloaded successfully': 'Etichette scaricate con successo',
  'Order history': 'Storico ordine',
  'Orders assigned to a picking list cannot have products added':
    'Non è possibile aggiungere prodotti ad ordini associati a picking list',
  order_template: 'template_ordine',
  'Address updated successfully': 'Indirizzo aggiornato con successo',
  'There was an error setting the selected payment':
    "Si è verificato un errore nell'impostare il pagamento selezionato",
  'Edit values': 'Modifica valori',
  'Cancel picking': 'Annulla prelievo',
  'Cancel shipment': 'Annulla spedizione',
  'Request shipment': 'Richiedi spedizione',
  'View visible products in catatlogue':
    'Visualizza prodotti visibili in catalogo',
  'View in catalogue': 'Visualizza in catalogo',
  'Ship in dropship': 'Spedisci in dropship',
  'Pack order': 'Imballa ordine',
  'Pick order': 'Preleva ordine',
  'Req. invoice': 'Fattura rich.',
  'Create goods return': 'Crea reso',
  'Apply discount': 'Applica sconto',
  'Cancel discount': 'Annulla sconto',
  'Reference copied successfully': 'Riferimento copiato con successo',
  'Order date required': 'Data ordine richiesta',
  'Order ref. num.': 'Rif. num. Ordine',
  'Edit order reference number': 'Modifica riferimento numero ordine',
  'Copy order reference number': 'Copia riferimento numero ordine',
  'Order alert': 'Alert ordine',
  Pack: 'Pack',
  'Total amount required': 'Importo totale richiesto',
  Packaging: 'Imballaggio',
  'Address saved successfully': 'Indirizzo salvato con successo',
  Loading: 'Caricamento',
  'Gift message': 'Messaggio regalo',
  'There is no meta info': 'Non ci sono meta informazioni',
  'Meta info': 'Meta informazioni',
  'New meta field': 'Nuovo campo meta',
  'Order subtotal cannot be negative':
    "Il subtotale dell'ordine non può essere negativo",
  "Verify that the discount doesn't exceed the order value":
    "Controllare che lo sconto di testata non superi il valore dell'ordine",
  'Cash on delivery VAT': 'IVA contrassegno',
  'order-rows': 'righe_ordine',
  Pick: 'Pick',
  'Processed product': 'Evaso',
  'Gift product': 'Prodotto regalo',
  'Promotion type': 'Tipologia promozione',
  'Promotion type required': 'Tipologia promozione richiesta',
  Secret: 'Secret',
  Create: 'Crea',
  "You can open this modal from the orders list page by pressing 'st' on your keyboard":
    "Puoi aprire questo modale anche dalla pagina della lista ordini premendo 'st' sulla tastiera",
  'Only orders in drafted status can be deleted':
    'Solo gli ordini in bozza possono essere eliminati',
  'Alternative SKUs': 'SKU alternativi',
  'Product search hint': 'Nome prodotto, SKU, barcode, note',
  Barcodes: 'Barcode',
  'Inventory date': 'Data inventario',
  'Short description': 'Descrizione breve',
  'Parent product': 'Prodotto padre',
  'Kit products': 'Prodotti kit',
  Categories: 'Categorie',
  'Main category': 'Categoria principale',
  'Duplicate order': 'Duplica ordine',
  'Download proforma invoice': 'Scarica fattura proforma',
  Availability: 'Disponibilità',
  Receiving: 'In arrivo',
  Scrapped: 'Invendibili',
  'Promotion name': 'Nome promozione',
  'Promotion start date': 'Data inizio promozione',
  'Promotion end date': 'Data fine promozione',
  'Promotion price': 'Prezzo promozione',
  'Min provision': 'Scorta minima',
  'Max provision': 'Scorta massima',
  'Pack qty': 'Qtà per confezione',
  'Pallet qty': 'Qtà per pallet',
  Width: 'Larghezza',
  Lenght: 'Larghezza',
  Height: 'Altezza',
  'Volume (cbm)': 'Volume (m³)',
  'Net weight (kg)': 'Peso netto (kg)',
  'Gross weight (kg)': 'Peso lordo (kg)',
  Family: 'Famiglia',
  '% Completeness': '% Completamento',
  'Picking notes': 'Note picking',
  'Infinite stock': 'Disponibilità infinita',
  'Batch management': 'Gestione lotti',
  'ABC Classification': 'Classificazione ABC',
  'Logistic description': 'Descrizione logistica',
  'Customs description': 'Descrizione doganale',
  'HS Code': 'Codice HS',
  'Origin country': "Paese d'origine",
  Sites: 'Ubicazioni predefinite',
  'Order tag': 'Tag ordine',
  Simple: 'Semplice',
  'With variants': 'A varianti',
  Kit: 'Kit',
  Package: 'Imballo',
  'Reload products': 'Ricarica prodotti',
  'Create new product': 'Crea nuovo prodotto',
  'products selected': 'prodotti selezionati',
  'Manage catalogue via file (beta)': 'Gestisci catalogo via file (beta)',
  'Manage catalogue through XLS file (beta new import)':
    'Gestisci catalogo tramite file XLS (beta nuovo import)',
  'Manage catalogue via file': 'Gestisci catalogo via file',
  'Manage catalogue through XLS file': 'Gestisci catalogo tramite file XLS',
  'Manage suppliers via file': 'Gestisci fornitori via file',
  'Edit products': 'Modifica prodotti',
  'Export stocks file': 'Esporta file giacenze',
  'Stocks history': 'Storico giacenze',
  'Manage products via file': 'Gestisci prodotti via file',
  'Edit sequentially': 'Modifica sequenzialmente',
  'Export stocks': 'Esporta giacenze',
  'Stocks date': 'Data giacenza',
  'Product deleted successfully': 'Prodotto eliminato con successo',
  'Stocks on': 'Giacenza al',
  'Product movements': 'Movimenti prodotto',
  'Product stocks': 'Giacenza prodotto',
  'Product variants': 'Varianti prodotto',
  product: 'prodotto',
  'Quick view': 'Visualizza',
  'View stocks for product': 'Visualizza giacenza prodotto',
  'Info product': 'Info prodotto',
  'View orders linked to product': 'Visualizza ordini collegati al prodotto',
  'View ordered qties for product':
    'Visualizza le qtà ordinate per il prodotto',
  'View incoming qties for product':
    'Visualizza le qtà in arrivo per il prodotto',
  'View sales for product': 'Visualizza le vendite del prodotto',
  Inventory: 'Inventario',
  'Lot required': 'Lotto richiesto',
  'Expiration date': 'Data di scadenza',
  'Expiration date required': 'Data di scadenza richiesta',
  'Serial required': 'Seriale richiesto',
  'Required data for channel management and structure':
    'Dati necessari per la struttura e la gestione del canale',
  'Channel name required': 'Nome canale di vendita richiesto',
  'Channel name': 'Nome canale di vendita',
  'Channel integration': 'Integrazione canale di vendita',
  'Integration required': 'Integrazione richiesta',
  'Storeden configuration': 'Configurazione Storeden',
  'Required data for connecting OrderPod and Storeden':
    'Dati necessari per il collegamento tra OrderPod e Storeden',
  Exchange: 'Exchange',
  'Storeden Exchange': 'Exchange Storeden',
  'Storeden Exchange required': 'Exchange Storeden richiesto',
  Key: 'Key',
  'Storeden Key': 'Key Storeden',
  'Storeden Key required': 'Key Storeden richiesta',
  'Shopify configuration': 'Configurazione Shopify',
  'Required data for connecting OrderPod and Shopify':
    'Dati necessari per il collegamento tra OrderPod e Shopify',
  'Shop name': 'Nome negozio',
  'Shop name required': 'Nome negozio richiesto',
  'First part of the Shopify URL: [shop-name].myshopify.com':
    "Parte iniziale dell'URL di Shopify: [nome-negozio].myshopify.com",
  Notification: 'Notifica',
  'User notification frequency': 'Frequenza di notifica utente',
  'Shopify notification frequency': 'Frequenza notifica Shopify',
  'Notification frequency required': 'Frequenza notifiche richiesta',
  'OAuth Client ID': 'OAuth Client ID',
  'OAuth Client Secret': 'OAuth Client Secret',
  'If OAuth Client ID is empty, then OAuth Client Secret must be empty as well':
    'Se OAuth Client ID è vuoto, allora anche OAuth Client Secret deve rimanere vuoto',
  'OAuth Client Secret required': 'OAuth Client Secret richiesto',
  'Warning: this channel uses OAuth, so you need to request the link for the Shopify app':
    "Attenzione: questo canale usa OAuth, quindi è necessario richiedere il link dell'app Shopify",
  'Site ID': 'ID sede',
  'Site ID required': 'ID sede richiesto',
  'Ignore orders not being shipped to the selected site':
    'Ignora ordini non destinati alla sede indicata',
  Active: 'Attivo',
  Inactive: 'Disattivo',
  'Ignore orders being shipped to a site different to the one specified in the ID site field':
    'Ignora gli ordini destinati ad una sede diversa da quella indicata nel campo ID sede',
  'WooCommerce configuration': 'Configurazione WooCommerce',
  'Required data for connecting OrderPod and WooCommerce':
    'Dati necessari per il collegamento tra OrderPod e WooCommerce',
  'URL required': 'URL richiesto',
  'Consumer Key': 'Consumer Key',
  'Consumer Key required': 'Consumer Key richiesta',
  'In order to generate the credentials, go to WooCommerce and choose in the left bar Settings > Advanced > REST API. From there, assign Read/Write permissions and them press Add Key':
    'Per generare le credenziali andare su WooCommerce e scegliere nella barra a sinistra Settings > Advanced > REST API. Da lì, assegnare permessi Read/Write e poi premere Add Key',
  'Consumer Secret required': 'Consumer Secret richiesto',
  'Disconnect external channel': 'Disconnetti canale esterno',
  'Connect external channel': 'Connetti canale esterno',
  'Print in progress': 'Stampa in corso',
  'Apply a discount to each row': 'Applica uno sconto ad ogni riga',
  'Apply a discount on the order total':
    "Applica uno sconto sul totale dell'ordine",
  'Row colors keys': 'Legenda colori righe',
  'Warning order row description': "Il flag 'Alert ordine' è attivato",
  'Splitted order row description': "L'ordine è stato diviso",
  'Returned order row description':
    "L'ordine è incluso in un reso (solo il bordo è colorato)",
  'Duplicated order row description': "L'ordine è stato duplicato",
  'Change status': 'Cambio stato',
  'Are you sure you want to change the order status to %s?':
    "Sei sicuro di voler cambiare lo stato dell'ordine in %s?",
  'Delete product': 'Elimina prodotto',
  'Hide all': 'Nascondi tutto',
  'Show all': 'Mostra tutto',
  'Order notes': 'Note ordine',
  'Weight (kg)': 'Peso (kg)',
  'Click here to reload the page': 'Clicca qui per ricaricare la pagina',
  'New OrderPod version available': 'Nuova versione di OrderPod disponibile',
  Equals: 'Uguale',
  'Less than': 'Minore di',
  'Greater than': 'Maggiore di',
  'Less or equal than': 'Minore o uguale a',
  'Greater or equal than': 'Maggiore o uguale a',
  Between: 'Compreso',
  Sunday: 'Domenica',
  Saturday: 'Sabato',
  Friday: 'Venerdì',
  Thursday: 'Giovedì',
  Wednesday: 'Mercoledì',
  Tuesday: 'Martedì',
  Monday: 'Lunedì',
  January: 'Gennaio',
  February: 'Febbraio',
  March: 'Marzo',
  April: 'Aprile',
  May: 'Maggio',
  June: 'Giugno',
  July: 'Luglio',
  August: 'Agosto',
  September: 'Settembre',
  October: 'Ottobre',
  November: 'Novembre',
  December: 'Dicembre',
  Today: 'Oggi',
  'No internet connection': 'Nessuna connessione internet',
  'Check your connection and try again':
    'Controlla la tua connessione e riprova',
  'Order Packed': 'Imballato',
  'Changes not applied. Please try again': 'Modifiche',
  Download: 'Scarica',
  'Product tags': 'Tag prodotti',
  'Len. Hei. Wid. / Weight': 'Lun. Alt. Lar. / Peso',
  cm: 'cm',
  'Product pick': 'Pick prodotto',
  'Ordered qty': 'Qtà ordinata',
  'Picked qty': 'Qtà prelevata',
  'To be picked qty': 'Qtà da prelevare',
  'Current stocks': 'Giacenze attuali',
  Path: 'Percorso',
  'Insert a quantity greater than 0': 'Inserire una quantità maggiore a 0',
  "It's not possible to pick more than the ordered quantity":
    'Non è possibile prelevare più della quantità ordinata',
  "It's not possible to pick a quantity greater than the one available for this batch":
    'Non è possibile prelevare una quantità maggiore al lotto disponibile',
  "It's not possible to pick more than the on hand quantity":
    'Non è possibile prelevare una quantità maggiore alla giacenza disponibile',
  Location: 'Ubicazione',
  Batch: 'Lotto',
  Picking: 'Prelievo',
  'Quantity limit reached. Reduce the input quantity':
    'Limite quantità raggiunto. Riduci la quantità inserita',
  'The product is not in stock': 'Il prodotto non ha giacenze',
  Lot: 'Lotto',
  Serial: 'Seriale',
  Expiration: 'Scadenza',
  'Available batches': 'Lotti disponibili',
  'Confirm pick': 'Conferma prelievo',
  Sender: 'Mittente',
  Recipient: 'Destinatario',
  'Coverage available': 'Evadibile',
  'Coverage unavailable': 'Non evadibile',
  Restore: 'Ripristina',
  'packing-lists': 'packing-list',
  'packing-list': 'packing-list',
  'Pick by order': 'Prelievo per ordine',
  'Pick by product': 'Prelievo massivo',
  'Started by': 'Iniziata da',
  'Ended by': 'Terminata da',
  'Packed orders': 'Ordini imballati',
  'Packed pieces': 'Pezzi imballati',
  'Packing start date': 'Data inizio packing',
  'Packing end date': 'Data termine packing',
  'Tot packing time': 'Tempo tot packing',
  'Tote code': 'Codice UDC',
  'Packing station': 'Postazione packing',
  'Labels printer required': 'Stampante etichette richiesta',
  'A4 printer required': 'Stampante A4 richiesta',
  'Packages location': 'Ubicazione imballi',
  'Print type': 'Tipologia stampa',
  Manual: 'Manuale',
  Automatic: 'Automatica',
  'Processing picking lists': 'Picking list in prelievo',
  'Currently there are no processing picking lists':
    'Non ci sono picking-list attualmente in prelievo',
  'Start to pack picking': 'Inizia ad imballare la picking',
  'Set packages location': 'Imposta ubicazione imballi',
  "You're about to start packing but you have not selected the packages location. Go back to the previous page and select it":
    "Stai per iniziare il pack ma non hai selezionato l'ubicazione per gli imballi. Torna alla lista di packing e selezionalo",
  'SKU or Product barcode': 'SKU o Barcode prodotto',
  'Orders num.': 'Num. ordini',
  'Pieces num.': 'Num. pezzi',
  'Totes num.': 'Num. UDC',
  'Orders status': 'Stato ordini',
  'Ref.': 'Rif.',
  Tote: 'UDC',
  'There are no totes used in the picking list':
    'Non ci sono UDC utilizzate nella picking list',
  'Start packing': 'Inizia packing',
  'Restore packing': 'Ripristina packing',
  'Reprint last order': 'Ristampa ultimo ordine',
  'Back to the search': 'Torna alla ricerca',
  Packing: 'Packing',
  'Used tote': 'Unità di carico utilizzata',
  'Packages number': 'Numero imballi',
  'Picking code': 'Codice prelievo',
  'Heavy products': 'Prodotti pesanti',
  'Bulky products': 'Prodotti voluminosi',
  'Order to pack': 'Ordine da imballare',
  Customization: 'Personalizzazione',
  Player: 'Giocatore',
  'Custom name': 'Scritta personalizzata',
  Patch: 'Patch',
  'Order progress': 'Avanzamento ordine',
  'There are no products to pack for the current order':
    "Non ci sono prodotti da imballare per l'ordine corrente",
  'Customized product': 'Prodotto personalizzato',
  'Gift order': 'Ordine regalo',
  'Pack.': 'Conf.',
  'Skip order': 'Salta ordine',
  'Confirm row': 'Conferma riga',
  'Last order': 'Ultimo ordine',
  'Order data': 'Dati ordine',
  'The address has more than 35 characters. Check validity':
    "L'indirizzo di spedizione supera i 35 caratteri. Controllarne la validità",
  'Shipping addr.': 'Ind. spedizione',
  'Total ordered products': 'Totale prodotti ordinati',
  'Edit order': 'Modifica ordine',
  'Edit address': 'Modifica indirizzo',
  'Edit carrier': 'Modifica corriere',
  'Scan a product or load<br />the first available order':
    'Scannerizza un prodotto o carica<br />il primo ordine disponibile',
  'Scan a product, a tote or load<br />the first available order':
    'Scannerizza un prodotto, una UDC o carica<br />il primo ordine disponibile',
  'Load order': 'Carica ordine',
  'Cancel label': 'Annulla etichetta',
  'Back to the order': "Torna all'ordine",
  'Address missing': 'Nessun indirizzo inserito',
  'No carrier selected': 'Nessun corriere selezionato',
  'Edit packages': 'Modifica imballi',
  'Packages not found': 'Imballi non trovati',
  'Missing order data': 'Dati ordine non trovati',
  'Missing packing data': 'Dati packing non trovati',
  'Orders not found': 'Ordini non trovati',
  Tot: 'Tot',
  Length: 'Lunghezza',
  'Package SKU or barcode': 'SKU o Barcode imballo',
  'Additional package SKU or barcode': 'SKU o Barcode imballo aggiuntivo',
  'Package search hint': 'Cerca un prodotto prelevato tramite SKU o barcode',
  'Package not found': 'Imballo non trovato',
  'SKU not valid': 'SKU non valido',
  'Package not available': 'Imballo non disponibile',
  'Package added': 'Imballo aggiunto',
  'This package is disabled. You need to enable it in order to use it':
    'Questo imballo è disabilitato. Devi abilitarlo per poterlo utilizzare',
  'Delete weight': 'Cancella peso',
  'Package disabled': 'Imballo disabilitato',
  'Packages missing. You need to add at least one package':
    'Imballi mancanti. Devi aggiungere almeno un imballo',
  'One or more sizes have the wrong value':
    'Una o più dimensioni hanno un valore errato',
  'There is more than one package. Change carrier':
    'È presente più di un collo. Cambia corriere',
  'The weight is more than 26kg. Change carrier':
    'Il peso supera i 26kg. Cambia corriere',
  'Packages summary': 'Riepilogo imballi',
  'Scanned package error': 'Errore scansione imballo',
  'Packages weight error': 'Errore peso colli',
  'Selected packages weight cannot be 0. Weight the packages':
    'Il peso dei colli selezionati non può essere 0. Pesa i colli',
  'Check packages': 'Controlla colli',
  'Possible package inversion. Check again':
    'Possibile inversione colli. Ricontrolla il contenuto',
  'Order transport': 'Trasporto ordine',
  'Order transport data': 'Dati relativi al trasporto ordine',
  'Transport type': 'Tipologia trasporto',
  'Additional carrier shipment settings':
    'Impostazioni aggiuntive del corriere per la spedizione',
  'Packing terminated successfully': 'Packing terminato con successo',
  'You packed': 'Hai imballato',
  'Packing time': 'Tempo di packing',
  'Order currently being picked': 'Ordine corrente in prelievo',
  'Completed/total orders': 'Ordini completati/totali',
  Increase: 'Carico',
  Decrease: 'Scarico',
  'Packing action': 'Imballaggio',
  Transfer: 'Trasferimento',
  Reception: 'Accettazione',
  Cancelation: 'Annullamento',
  Replenish: 'Missione di abbassamento',
  'Mov. qty': 'Qtà mov.',
  'Mov. code': 'Codice mov.',
  'Mov. detail': 'Dettaglio mov.',
  'Loc. code': 'Cod. ubi.',
  'Document number': 'Numero documento',
  'Document ref.': 'Rif. documento',
  'Movement search hint': 'Nome | SKU Prodotto',
  Movements: 'Movimenti',
  'Location code': 'Codice ubicazione',
  'Reload movements': 'Ricarica movimenti',
  'Select columns': 'Seleziona colonne',
  movement: 'movimento',
  movements: 'movimenti',
  'Movevemnt code': 'Codice movimento',
  'Confirmed plural': 'Confermati',
  Area: 'Area',
  'Reserved qty': 'Qtà riservata',
  stock: 'giacenza',
  stocks: 'giacenze',
  Stocks: 'Giacenze',
  'Stock stock': 'Stock',
  'stocks selected': 'giacenze selezionate',
  'Reload stocks': 'Ricarica giacenze',
  'Ticket pallet': 'Ticket pallet',
  'No reply': 'Senza risposta',
  Scheduled: 'Programmato',
  'One-off': 'Una tantum',
  'Execution deleted successfully': 'Esecuzione eliminata con successo',
  'Delete execution': 'Elimina esecuzione',
  'You are about to delete the execution <strong>%s</strong> of the <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare l'esecuzione <strong>%s</strong> del <strong>%s</strong>. Procedere all'eliminazione?",
  Executions: 'Esecuzioni',
  'executions selected': 'esecuzioni selezionate',
  'Reload executions': 'Ricarica esecuzioni',
  executions: 'esecuzioni',
  execution: 'esecuzione',
  'Started at': 'Iniziato a',
  'Finished at': 'Terminato a',
  Activity: 'Attività',
  Data: 'Dati',
  activity: 'attività',
  activities: 'attività',
  'Reload activities': 'Ricarica attività',
  'Create new activity': 'Crea nuova attività',
  'Activity deleted successfully': 'Attività eliminata con successo',
  'Activity is running': 'Attività in esecuzione',
  'Delete activity': 'Elimina attività',
  'You are about to delete the activity <strong>%s</strong> of the <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare l'attività <strong>%s</strong> del <strong>%s</strong>. Procedere all'eliminazione?",
  Activities: 'Attività',
  'Activity updated successfully': 'Attività aggiornata con successo',
  'Start activity': 'Avvia attività',
  'Activity logs': 'Log attività',
  'Unable to edit cronjob. You need to create an activity first':
    "Impossibile modificare cronjob. Devi prima creare un'attività",
  'Required data for activity management and structure':
    "Dati necessari per la struttura e la gestione dell'attività",
  'Retries max number': 'Massimo numero di tentativi',
  Planning: 'Pianificazione',
  'Activity planning': "Pianificazione dell'attività",
  'Sending email': 'Invio email',
  'Data needed for sending email': "Dati necessari per l'invio dell'email",
  'On completion': 'Al termine',
  'On fail': 'Al fallimento',
  'Enter a recipient': 'Inserisci un destinatario',
  'No email entered': 'Nessuna email inserita',
  'Required data for activity configuration':
    "Dati necessari per la configurazione dell'attività",
  'Required field': 'Campo richiesto',
  'Activity new password': "Nuova password dell'attività",
  minutes: 'minuti',
  hours: 'ore',
  day: 'giorno',
  month: 'mese',
  week: 'settimana',
  'day of the month': 'giorno del mese',
  weekday: 'giorno della settimana',
  Minutes: 'Minuti',
  'All minutes': 'Tutti i minuti',
  'Even minutes': 'Minuti pari',
  'Odd minutes': 'Minuti dispari',
  Hours: 'Ore',
  'All hours': 'Tutte le ore',
  'Even hours': 'Ore pari',
  'Odd hours': 'Ore dispari',
  Days: 'Giorni',
  'All days': 'Tutti i giorni',
  'Even days': 'Giorni pari',
  'Odd days': 'Giorni dispari',
  Months: 'Mesi',
  'All months': 'Tutti i mesi',
  'Even months': 'Mesi pari',
  'Odd months': 'Mesi dispari',
  Weekdays: 'Giorni della settimana',
  'Mon-Fri': 'Lun-Ven',
  'Sat-Sun': 'Sab-Dom',
  logs: 'log',
  'No logs for this execution': 'Nessun log per questa esecuzione',
  'Execution logs': 'Log esecuzione',
  'Delete catalog': 'Elimina catalogo',
  'You are about to delete the catalog <strong>%s</strong>. Proceed with deletion?':
    "Stai per eliminare questo catalogo. Procedere all'eliminazione?",
  catalogs: 'cataloghi',
  catalog: 'catalogo',
  Catalogs: 'Cataloghi',
  'Reload catalogs': 'Ricarica cataloghi',
  'Create new catalog': 'Crea nuovo catalogo',
  'Catalog not found': 'Catalogo non trovato',
  'Required data for catalog management and structure':
    'Dati necessari per la struttura e la gestione del catalogo',
  'Additional data for products visualization':
    'Dati aggiuntivi inerenti alla visualizzazione dei prodotti',
  Languages: 'Lingue',
  'Categories tree': 'Albero categorie',
  'Attributes group': 'Gruppi di attributi',
  'Select a packages location': "Seleziona un'ubicazione imballi",
  'The lot management of products that are either being managed in a picking list or have scrapper quantity greater than 0 cannot be edited':
    "Non è possibile modificare gestione lotti di prodotti che sono o in gestione all'interno di una picking list o che hanno della quantità non conforme",
  'The lot management of products that have some quantities that already have a batch signature cannot be edited':
    'Non è possibile modificare gestione lotti di prodotti che hanno già della quantità con una firma lotto',
  'Batch management cannot be changed while the product has stock':
    'La gestione lotti non può essere modificata fintanto che il prodotto ha giacenza',
  Selected_P: 'Selezionati',
  'Upload file': 'Carica file',
  'Add file': 'Aggiungi file',
  'Select file': 'Seleziona file',
  'Cancel upload': 'Annulla caricamento',
  'In order to continue managing these files all additional parameters must be filled in':
    'Per poter la continuare con la gestione via file è necessario che tutti i parametri aggiuntivi siano compilati',
  'Missing fields': 'Campi mancanti',
  'Upload or select files': 'Carica o seleziona i file',
  'There are no attached files': 'Non ci sono file allegati',
  'Updload date': 'Data caricamento',
  'Selected file': 'File selezionato',
  'File already present in database': 'File già presente nel database',
  'Rename file': 'Rinomina file',
  'File uploaded successfully': 'File caricato con successo',
  Uploading: 'In caricamento',
  'There was an error while uploading this file':
    'Si è verificato un errore durante il caricamento del file',
  Rename: 'Rinomina',
  Riprova: 'Retry',
  'Drag and drop the file here': 'Trascina qui il file',
  'or select it from your computer': 'oppure selezionalo dal tuo computer',
  'Additional parameters': 'Parametri aggiuntivi',
  'Parameter required': 'Parametro richiesto',
  'Selected files': 'File selezionati',
  'Set value': 'Imposta valore',
  'Delete value': 'Cancella valore',
  'Add value': 'Aggiungi valore',
  'Remove value': 'Rimuovi valore',
  'Sum value': 'Somma valore',
  'Subtract value': 'Sottrai valore',
  'Multiply value': 'Moltiplica valore',
  'Divide value': 'Dividi valore',
}
